import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs/operators';
import { CabecalhoDTO } from 'src/app/entity/dto/cabecalho.component';
import { DropDownListDTO } from 'src/app/entity/dto/dropdownlist.component';
import { EnumForm } from 'src/app/entity/enum/enum-form';
import { EnumFormType } from 'src/app/entity/enum/enum-form-type';
import { FormularioService } from 'src/app/services/formulario.service';
import { GeneralService } from 'src/app/services/general.service';
import { NotificationService } from 'src/app/services/notification.service';
import { FormSequenceManageComponent } from './form-sequenceManage.component';
import { LogicSequenceStrategyService } from '../../services/logic-sequence-strategy.service';
import { TubularesModel } from "../../model/tubulares.model";

@Component({
  selector: 'app-result-form-sequenceManage',
  templateUrl: './result-form-sequenceManage.component.html',
  styleUrls: ['./result-form-sequenceManage.component.scss']

})

export class ResultFormSequenceManageComponent implements OnInit, AfterViewInit {

  public header?: CabecalhoDTO;
  public listCd006Info?: any[];
  public listSec002Info?: any[];
  listDadosFisiologicos?: any[];
  listDadosFisiologicosUnicos?: any[];
  lotesSemResultadoQualidadeFisiologica: string;

  public listSequenceByContract?: any[];
  public minDefeitosPond = 0;
  public groupedListByDefeitosPond?: any[];
  public orderedListByContract?: any[];
  public orderedListByContractWithSdev?: any[];
  public listChangedTipoColheita?: any[];

  public listSequenceByLote?: any[];
  public listLotePorContrato?: any[];
  public listSequenceByLoteSegregacao?: any[];
  public groupedListLotesByDefeitosPond?: any[];
  public groupedListLotesByDefeitosPondSegregacao?: any[];
  public minDefeitosPondLote = 0;
  public minPesoMedioPondLote = 0;
  public orderedListByLote = [];
  public orderedMarkedListByLote = [];
  public orderedMarkedListByAprovado = [];
  public orderedMarkedListByLoteSequenciamento = [];
  public tabelaLotesSequenciaOtimizada = [];
  public tabelaLotesSegregadosSequenciaOtimizada = [];
  public tabelaFaixasAzulClaro = [];
  public tabelaFaixasAzulCampo = [];
  public tabelaFaixasAzulPlanta = [];
  public tabelaFaixasAzulEscuro = [];
  public tabelaFaixasVermelhas = [];
  public tabelaSemFaixasVermelhas = [];
  public tabelaFaixas = [];
  public listaLotesAprovada = [];
  public orderedMarkedListByLoteSegregado = [];
  public orderedMarkedListByLoteNaoSegregado = [];
  public orderedMarkedListByLoteSegregadoInicial = [];
  public orderedMarkedListByLoteSegregadoInicialReal = [];
  public orderedMarkedListByLoteSegregadoFinal = [];
  public orderedMarkedListByLoteSegregadoFaixasVermelhas = [];
  public lotesSegregadoFaixasAzulClaro = [];
  public lotesSegregadoFaixasAzulCampo = [];
  public lotesSegregadoFaixasAzulPlanta = [];
  public lotesSegregadoFaixasAzulEscuro = [];
  public lotesSegregadoFaixasVermelhas = [];
  public listLotesSegregadosFaixasVermelhas = [];
  public repeatedDiscardedValues = [];
  public orderedListByLoteWithSdev?: any[];
  public loteNumber = 1;
  public vazoesByContract = [];
  public tempoSiloByLote = [];
  public contratoAtual?: any;
  public proximoContrato?: any;
  public listContratos?: any[];
  public ordemContratos?: any[];
  public contratos = [];

  public enableBusca = true;
  public enableReport = false;
  public enableVolume = false;
  public enableDefeitosLeves = false;
  public enablePeneiras = false;
  public enableTipoColheita = false;
  public enableTubulares = false;
  public enableTempoSilo = false;
  public enableSite = true;

  public enableFundoA = false;
  public enableFundoB = false;
  public enableTopoA = false;
  public enableTopoB = false;

  public enableLegendaVermelha = false;
  public enableLegendaAmarela = false;
  public enableLegendaLaranja = false;
  public enableLegendaDesvio5p = false;
  public enablelotesSemResultadoQualidadeFisiologica = false;
  public enablePeneiraReprovada = false;

  public contratosDefeitos = '';
  public tiposDefeitos = '';
  public sugestedC3?: number;
  public sugestedTopo?: number;

  vazaoTonPeneira21: number = 1;
  vazaoTonPeneira19: number = 1;
  vazaoTonPeneira16: number = 1;
  vazaoTonPeneira13ob?: number;
  vazaoTonPeneira125ob?: number;
  vazaoTonPeneira12ob?: number;

  tubulares_21: number;
  tubulares_19: number;
  tubulares_16: number;
  tubulares_13ob: number;
  tubulares_125ob: number;
  tubulares_12ob: number;
  listLotesTubulares: TubularesModel[] = [];

  public selectedSite?: string;
  public selectedSafras?: string;
  public selectedHibrido?: string;
  public selectedLotes?: string;
  public selectedPeneiras?: string;
  public selectedPrioridadeSequenciamento?: number;
  public selectedLotesRegraSegragacao = [];
  public selectedMisturarTonsAzul: string;
  public listPesoMedio = [];
  public listLotesSequenciamento = [];
  public listLotesSequenciamentoAprovadaPorContrato = [];
  public listDefeitosTotaisPonderado = [];
  public listaLotes = [];
  public somaPesoMedio?: number;
  public somaDefeitosTotaisPonderado?: number;
  public maiorTotalPrioridadeSequenciamento: number;
  public menorTotalPrioridadeSequenciamento?: number;
  public menorTotalPrioridadeSequenciamentoAux?: number;
  public totalPrioridadeSequenciamento: number = 0;
  public calculoDefeitosTotaisPonderado: number;
  public calculoPesoMedioPonderado: number;
  isMensagemTesteDadosFisiologicos: boolean = false;

  public isUnicoContrato: boolean = false;

  public dataSourceByContract?: MatTableDataSource<any>;
  /*public displayedColumnsByContract?: string[] = ['Contratos', 'JanelaPlantio', 'Ambiente', 'Volume', 'TotalDefeitosPonderados', 'MediaC1Prc', 'MediaC2Prc', 'MediaC3Prc', 'MediaR1Prc', 'MediaR2Prc', 'MediaR3Prc',
    'PesoMedioC1Prc', 'PesoMedioC2Prc', 'PesoMedioC3Prc', 'PesoMedioR1Prc', 'PesoMedioR2Prc', 'PesoMedioR3Prc'];*/
  public displayedColumnsByContract?: string[] = ['Contratos', /*'JanelaPlantio', 'Ambiente',*/ 'Volume', 'TotalDefeitosPonderados', 'TotalDefeitosSeverosPonderados', 'MediaC1Prc', 'MediaC2Prc',
    'MediaC3Prc', 'MediaR1Prc', 'MediaR2Prc', 'MediaR3Prc', 'PesoMedioPonderadoPrc'];

  public dataSourceByLote?: MatTableDataSource<any>;
  public dataSourceByLoteSegregado?: MatTableDataSource<any>;
  public displayedColumnsByLote?: string[] = ['Contratos', /*'JanelaPlantio', 'Ambiente',*/ 'Silo', 'Lotes', 'Soma', 'TotalDefeitosPonderados', 'MediaC1Prc', 'MediaC2Prc', 'MediaC3Prc', 'MediaR1Prc', 'MediaR2Prc', 'MediaR3Prc', 'MediaG1Prc', 'MediaG2G3Prc',
    'PesoMedioC1Prc', 'PesoMedioC2Prc', 'PesoMedioC3Prc', 'PesoMedioR1Prc', 'PesoMedioR2Prc', 'PesoMedioR3Prc', 'PesoMedioPonderadoPrc', 'Faixas'];

  public fieldsSequenceByContract = [
    'total_defeitos_totais_ponderado',
    'total_defeitos_severos_ponderado',
    'c1_prc',
    'c2_prc',
    'c3_prc',
    'r1_prc',
    'r2_prc',
    'r3_prc',
    'descarte_fundo_prc',
    'peso_medio_c1',
    'peso_medio_c2',
    'peso_medio_c3',
    'peso_medio_r1',
    'peso_medio_r2',
    'peso_medio_r3',
    'peso_medio_ponderado',
    'total_sequenciamento',
  ];

  tubulares = [
    {
      site_recebimento: 'CVE',
      peneira_21: 18,
      peneira_19: 12,
      peneira_16: 10,
      peneira_13ob: 18,
      peneira_125ob: 12,
      peneira_12ob: 10
    },
    {
      site_recebimento: 'ITA',
      peneira_21: 18,
      peneira_19: 12,
      peneira_16: 6,
      peneira_13ob: 14,
      peneira_125ob: 12,
      peneira_12ob: 12
    },
    {
      site_recebimento: 'PTU',
      peneira_21: 16,
      peneira_19: 10,
      peneira_16: 4,
      peneira_13ob: 18,
      peneira_125ob: 12,
      peneira_12ob: 8
    },
    {
      site_recebimento: 'UDI',
      peneira_21: 18,
      peneira_19: 12,
      peneira_16: 8,
      peneira_13ob: 18,
      peneira_125ob: 12,
      peneira_12ob: 8
    }
  ]

  @ViewChild(FormSequenceManageComponent, { static: false }) formSequenceManageComponent: FormSequenceManageComponent;
  comment: string = null;
  pc003: any;
  enableComment: boolean;

  // tslint:disable-next-line: max-line-length
  constructor(protected generalService: GeneralService, protected formularioService: FormularioService,
    protected notificationService: NotificationService, protected logicSequenceStrategyService: LogicSequenceStrategyService) {
    this.header = new CabecalhoDTO();
  }

  async ngAfterViewInit(): Promise<void> {
    this.formSequenceManageComponent.formulario.get('Site_recebimento').setValue(this.generalService.getLocalStorageDataSite());

  }

  async ngOnInit(): Promise<void> {
    this.header = this.generalService.createHeader(EnumForm.ManageSequence, EnumFormType.Details);
  }

  async makeReport(event?: any): Promise<void> {
    await this.getInfo();
  }

  async getListSec002(lotesStr: string): Promise<void> {
    await this.formularioService.getInfoFromSec002DataByLotes(lotesStr).pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listSec002Info = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para informações da Sec002`);
    });
  }

  async getListDadosFisiologicos(lotesStr: string): Promise<void> {
    await this.formularioService.getInfoReportFromDadosFisiologicosDataByLotes(lotesStr).pipe(take(1)).toPromise().then(response => {
      if (!!response?.data) {
        this.listDadosFisiologicos = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        this.listDadosFisiologicosUnicos = this.listDadosFisiologicos.reduce((acc, current) => {
          const exists = acc.find((obj) => obj.lote === current.lote);
          if (!exists) {
            acc.push(current);
          }
          return acc;
        }, []);
      }
    }).catch(async (error: HttpErrorResponse) => {
      this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para informações dos dados fisiológicos`);
    });
  }

  async getListCd006(lotesStr: string, peneiras?: string): Promise<void> {
    if (!!peneiras) {
      var peneiraArr = peneiras.split("-");

      await this.formularioService.getInfoFromCd006DataByPeneiras(lotesStr, +peneiraArr[0], +peneiraArr[1], +peneiraArr[2]).pipe(take(1)).toPromise().then(response => {
        if (!!response?.data) {
          this.listCd006Info = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        }
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para informações da CD006 por peneiras`);
      });
    }
    else {
      await this.formularioService.getInfoReportFromCd006DataByLotes(lotesStr).pipe(take(1)).toPromise().then(response => {
        if (!!response?.data) {
          this.listCd006Info = this.generalService.orderByDropDownList(response.data as DropDownListDTO[]);
        }
      }).catch(async (error: HttpErrorResponse) => {
        this.notificationService.showNotificationError(error, `Ocorreu um Erro para buscar do banco de dados para informações da CD006 por lote`);
      });
    }
  }
  async getCommentHibrido(hibrido: string, safras: string[]) {
    // const newSafra = safra
    // const ano = safra
    await this.formularioService.getAllFilter('pc003', {
      filters: { hibrido_rnc: hibrido }, columns: [
        "pc_hibrido",
        "comment"
      ]
    }).pipe(take(1)).toPromise().then(async (response: any) => {

      this.pc003 = response.data;
    })
  }


  async getInfo(): Promise<void> {
    const lotes = this.formSequenceManageComponent.formulario.get('Lote_ds')?.value;
    const hibrido = this.formSequenceManageComponent.formulario.get('Hibrido_rnc_linhagem')?.value as string;
    const safras = this.formSequenceManageComponent.formulario.get('Safra')?.value;
    const peneiras = this.formSequenceManageComponent.formulario.get('Peneiras')?.value;
    const site = this.formSequenceManageComponent.formulario.get('Site_recebimento')?.value as string;
    const prioridadeSequenciamento = this.formSequenceManageComponent.formulario.get('PrioridadeSequenciamento')?.value;
    const misturarTonsAzul = this.formSequenceManageComponent.formulario.get('MisturarTonsAzul')?.value as string;
    const listLotesRegraSegragacao = this.formSequenceManageComponent.listLotesRegraSegragacao;

    if (!!hibrido && !!lotes && lotes?.length > 0) {
      var lotesStr = '';
      lotes.forEach(lote => {
        lotesStr += "'" + lote + "', ";
      })
      lotesStr = lotesStr.slice(0, -2);

      var safraStr = '';
      safras.forEach(safra => {
        safraStr += "'" + safra + "', ";
      })
      safraStr = safraStr.slice(0, -2);

      this.selectedHibrido = hibrido;
      this.selectedLotes = lotesStr.split("'").join('');
      this.selectedPeneiras = peneiras;
      this.selectedSafras = safraStr.split("'").join('');
      this.selectedSite = site;
      this.selectedPrioridadeSequenciamento = prioridadeSequenciamento;
      this.selectedLotesRegraSegragacao = listLotesRegraSegragacao;
      this.selectedMisturarTonsAzul = misturarTonsAzul;

      if (hibrido.endsWith('4')) {
        if (!!peneiras) {
          await Promise.all([
            this.getListSec002(lotesStr),
            this.getListCd006(lotesStr, peneiras),
            this.getListDadosFisiologicos(lotesStr)]);
          await this.enableTexts();
        }
      }
      else {
        await Promise.all([
          this.getListSec002(lotesStr),
          this.getListCd006(lotesStr),
          this.getCommentHibrido(hibrido, safras),
          this.getListDadosFisiologicos(lotesStr),
        ]);
        await this.enableTexts();
      }
    }
  }

  async enableTexts(): Promise<void> {
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    htmlElement.scrollTop = 0;
    bodyElement.scrollTop = 0;
    this.enableReport = false;
    this.enableVolume = false;
    this.enableDefeitosLeves = false;
    this.enablePeneiras = false;
    this.enableFundoA = false;
    this.enableFundoB = false;
    this.enableTopoA = false;
    this.enableTopoB = false;
    this.enableTempoSilo = false;
    this.enableLegendaAmarela = false;
    this.enableLegendaVermelha = false;
    this.enableLegendaLaranja = false;
    this.enableLegendaDesvio5p = false;
    this.enableComment = false;

    this.orderedListByContract = [];
    this.orderedListByLote = [];
    this.orderedMarkedListByLote = [];
    this.orderedListByLoteWithSdev = [];
    this.vazoesByContract = [];
    this.loteNumber = 1;

    if (!!this.listSec002Info && this.listSec002Info.length > 0) {
      await this.checkVolume();
      await this.checkTempoSilo();
    }
    if (!!this.listCd006Info && this.listCd006Info.length > 0) {
      await this.checkDefeitosLeves();
      await this.checkPeneiraC3();
      await this.checkFundoTopo();
      await this.createSequenceByContract();
      await this.createSequenceByLote();
      await this.calculaVazoes();
    }
    await this.checkComment();
    this.enableBusca = false;
    this.enableReport = true;
  }

  async checkComment(): Promise<void> {
    // const safras = this.formSequenceManageComponent.formulario.get('Safra')?.value;
    // let pcSafras = safras.map(s => {
    //     return s.includes('VE') ? 'SUMMER' : 'WINTER';
    // });
    // let pcAnos = safras.map(s => {
    //     return "20" + s[s.length - 2] + s[s.length - 1];
    // })
    this.pc003 = this.pc003.filter(p => p.comment != '' && p.comment != null)

    this.enableComment = this.pc003.length > 0;

  }

  async checkVolume(): Promise<void> {
    var totalVolume = 0;

    this.listSec002Info.forEach(info => {
      if (!!info.peso_debulha_kg)
        totalVolume += +info.peso_debulha_kg;
    })

    if (totalVolume < 150000) {
      this.enableVolume = true;
    }
  }


  async checkDefeitosLeves(): Promise<void> {
    this.contratosDefeitos = '';
    this.tiposDefeitos = '';

    this.listCd006Info.forEach(info => {
      if (((!!info.popped_kernel_leves_ponderado && info.popped_kernel_leves_ponderado > 0))
        && (!!info.total_defeitos_leves_ponderado && info.total_defeitos_leves_ponderado >= 2)) {
        if (!this.tiposDefeitos.includes("popped kernel"))
          this.tiposDefeitos += 'popped kernel, '
      }

      if (((!!info.silk_cut_leves_ponderado && info.silk_cut_leves_ponderado > 0))
        && (!!info.total_defeitos_leves_ponderado && info.total_defeitos_leves_ponderado >= 2)) {
        if (!this.tiposDefeitos.includes("silk cut"))
          this.tiposDefeitos += 'silk cut, '
      }

      if (((!!info.furados_leves_ponderado && info.furados_leves_ponderado > 0))
        && (!!info.total_defeitos_leves_ponderado && info.total_defeitos_leves_ponderado >= 2)) {
        if (!this.tiposDefeitos.includes("furados"))
          this.tiposDefeitos += 'furados, '
      }

      if (((!!info.popped_kernel_leves_ponderado && info.popped_kernel_leves_ponderado > 0)
        || (!!info.silk_cut_leves_ponderado && info.silk_cut_leves_ponderado > 0)
        || (!!info.furados_leves_ponderado && info.furados_leves_ponderado > 0))
        && (!!info.total_defeitos_leves_ponderado && info.total_defeitos_leves_ponderado >= 2)
      ) {
        if (!!info.contrato_juridico) {
          if (!this.contratosDefeitos.includes(info.contrato_juridico))
            this.contratosDefeitos += info.contrato_juridico + ', ';

        }
      }
    })

    if (this.contratosDefeitos.length > 2) {
      this.contratosDefeitos = this.contratosDefeitos.slice(0, -2);
      var pos = this.contratosDefeitos.lastIndexOf(',');
      this.contratosDefeitos = this.contratosDefeitos.substring(0, pos) + ' e' + this.contratosDefeitos.substring(pos + 1);

      this.tiposDefeitos = this.tiposDefeitos.slice(0, -2);
      var pos = this.tiposDefeitos.lastIndexOf(',');
      this.tiposDefeitos = this.tiposDefeitos.substring(0, pos) + ' e' + this.tiposDefeitos.substring(pos + 1);

      this.enableDefeitosLeves = true;
    }
  }

  async checkPeneiraC3(): Promise<void> {
    var totalVolumeDs: number = 0;
    var totalPrcPond: number = 0;

    // tslint:disable-next-line: max-line-length
    this.listCd006Info.forEach(element => {
      var volumeDs: number = element.volume_ds;
      var prcC3: number = element.c3_prc;
      var prcR3: number = element.r3_prc;

      if (volumeDs !== null && prcC3 !== null && prcR3 !== null) {
        totalPrcPond += (+prcC3 + +prcR3) * (+volumeDs);
        totalVolumeDs += +volumeDs
      }
    });

    var peneiraPond = totalPrcPond / totalVolumeDs;

    if (!!peneiraPond && peneiraPond >= 45) {
      this.enablePeneiras = true;
    }
  }

  async checkFundoTopo(): Promise<void> {
    var totalVolumeDs: number = 0;
    var totalVolumeDsSabugo: number = 0;
    var totalPrcPond: number = 0;
    var totalPesoSabugoPond: number = 0;

    // tslint:disable-next-line: max-line-length
    this.listCd006Info.forEach(element => {
      var volumeDs: number = element.volume_ds;
      var prcC3: number = element.c3_prc;
      var prcR3: number = element.r3_prc;
      var pesoSabugo: number = element.peso_sabugo_penduculo;
      var peneiraC3: number = element.c3_peneira;

      if (volumeDs !== null && prcC3 !== null && prcR3 !== null) {
        totalPrcPond += (+prcC3 + +prcR3) * (+volumeDs);
        totalVolumeDs += +volumeDs
      }

      if (volumeDs !== null && pesoSabugo !== null) {
        totalPesoSabugoPond += (+pesoSabugo) * (+volumeDs);
        totalVolumeDsSabugo += +volumeDs
      }

      if (peneiraC3 !== null) {
        this.sugestedC3 = peneiraC3;
      }

    });

    var peneiraPond = totalPrcPond / totalVolumeDs;
    var pesoSabugoPonderado = totalPesoSabugoPond / totalVolumeDsSabugo;

    if (!!peneiraPond && peneiraPond <= 5) {
      this.enableFundoA = true;
      this.enableFundoB = false;
      this.sugestedC3 = this.sugestedC3 + 1;
    }
    else {
      this.enableFundoA = false;
      this.enableFundoB = true;
    }

    if (!!pesoSabugoPonderado && pesoSabugoPonderado < 1) {
      this.enableTopoA = true;
      this.enableTopoB = false;

      var repeated = this.getModes();

      if (!!repeated && repeated != "null")
        this.sugestedTopo = repeated;
      else
        this.sugestedTopo = null;

    }
    else {
      this.enableTopoA = false;
      this.enableTopoB = true;

      var repeated = this.getModes();

      if (!!repeated && repeated != "null")
        this.sugestedTopo = repeated;
      else
        this.sugestedTopo = null;
    }
  }

  getModes(): any {
    var frequency = [];
    var maxFreq = 0;
    var modes = [];

    for (var i in this.listCd006Info) {
      if (this.listCd006Info[i].sugestao_peneira_topo !== null)
        frequency[this.listCd006Info[i].sugestao_peneira_topo] = (frequency[this.listCd006Info[i].sugestao_peneira_topo] || 0) + 1;

      if (frequency[this.listCd006Info[i].sugestao_peneira_topo] > maxFreq) {
        maxFreq = frequency[this.listCd006Info[i].sugestao_peneira_topo];
      }
    }

    for (var k in frequency) {
      if (frequency[k] == maxFreq) {
        modes.push(k);
      }
    }

    if (modes.length > 0)
      return modes[0];
    else
      return null;
  }

  async createSequenceByContract(): Promise<void> {
    // Agrupar por Contrato
    this.listSequenceByContract = this.listCd006Info.reduce(function (r, a) {
      r[a.contrato_juridico] = r[a.contrato_juridico] || [];
      r[a.contrato_juridico].push(a);
      return r;
    }, Object.create(null));

    for (let key of Object.keys(this.listSequenceByContract)) {
      let contList = this.listSequenceByContract[key];
      // Inicializar listas para os cálculos
      contList.defeitos_ponderados = contList;
      contList.peneiras_prc = contList;
      contList.media_peso = contList;

      contList.contrato_abreviado = key;
      contList.volume_total = 0;
      contList.total_defeitos_totais_ponderado = 0;

      // Calcular Volume Total e Buscar Tipo Colheita
      contList.forEach(value => {
        contList.volume_total += value.volume_ds;

        if (value.tipo_colheita)
          contList.tipo_colheita = value.tipo_colheita;
        if (!!value.ambiente)
          contList.ambiente = value.ambiente;

        if (!!value.janela_plantio)
          contList.janela_plantio = value.janela_plantio;

        // Atualizar total_defeitos_totais_ponderado
        contList.total_defeitos_totais_ponderado += value.total_defeitos_totais_ponderado;
      });

      this.fieldsSequenceByContract.forEach(fieldName => {
        const volumes = contList.map(item => item.volume_ds);
        const valores = contList.map(item => item[fieldName]);

        // Calculando a mediana ponderada
        contList['mediana_' + fieldName] = this.calculaMediaPonderada(volumes, valores);
      });
      // Remover outliers e Calcular Valores Ponderados
      this.fieldsSequenceByContract.forEach(fieldName => {
        // Remover outliers Defeitos Ponderados
        if (fieldName.endsWith('ponderado')) {
          contList.defeitos_ponderados = contList.defeitos_ponderados.filter(value => Math.abs(value[fieldName] - contList['mediana_' + fieldName]) < 5);
        }
        // Remover outliers Porcentagens
        if (fieldName.endsWith('1_prc') || fieldName.endsWith('2_prc') || fieldName.endsWith('3_prc')) {
          contList.peneiras_prc = contList.peneiras_prc.filter(value => Math.abs(value[fieldName] - contList['mediana_' + fieldName]) < 5);
        }
        // Remover outliers Media
        if (fieldName.startsWith('peso_medio')) {
          contList.media_peso = contList.media_peso.map(value => {
            if (!(Math.abs(value[fieldName] - contList['mediana_' + fieldName]) < contList['mediana_' + fieldName] * 0.25))
              value[fieldName] = null;
            return value;
          });
        }
      });

      // Calcular Valores Ponderados
      this.fieldsSequenceByContract.forEach(fieldName => {
        if (fieldName.endsWith('ponderado')) {
          contList.valor_defeitos_pond = this.calculoMediaPond('volume_ds', fieldName, contList.defeitos_ponderados);
        }
        if (fieldName.endsWith('prc')) {
          contList['valor_' + fieldName + '_pond'] = this.calculoMediaPond('volume_ds', fieldName, contList.peneiras_prc);
        }
        if (fieldName.startsWith('peso_medio')) {
          contList['valor_' + fieldName + '_pond'] = this.calculoMediaPond('volume_ds', fieldName, contList.media_peso);
        }
      });
    }

    // Calcular desvios
    this.fieldsSequenceByContract.forEach(fieldName => {
      if (fieldName.startsWith('peso_medio')) {
        this.listSequenceByContract[fieldName + '_sdev'] = this.calculoDesvioPadrao(this.listSequenceByContract, 'valor_' + fieldName + '_pond');
      }
    });

    // Buscar peneira com Maior desvio
    const peneiraMaiorSdev = this.buscarCampoComMaiorDesvio(this.listSequenceByContract);

    // Buscar total de defeito ponderado minimo
    this.minDefeitosPond = this.buscarValorMinimo(this.listSequenceByContract, 'valor_defeitos_pond');

    // Agrupar por defeitos ponderados
    this.groupedListByDefeitosPond = this.agruparPorFuncao(this.listSequenceByContract, 'valor_defeitos_pond');

    // Ordenar Dentro dos grupos
    this.ordenarGrupos(this.groupedListByDefeitosPond, 'valor_peso_medio_' + peneiraMaiorSdev + '_pond');

    // Busca mudanças de Tipo de Colheita
    this.listaMudancaTipoColheita(this.orderedListByContract);

    // Insere linhas de Sdev
    // this.insertSdevByContract(this.orderedListByContract);
    this.dataSourceByContract = new MatTableDataSource(this.orderedListByContract);
  }

  calculaMediaPonderada(lotes: number[], defeitos: number[]): number {
    let numerador = 0;
    let denominador = 0;

    for (let i = 0; i < lotes.length; i++) {
      numerador += defeitos[i] * lotes[i];
      denominador += lotes[i];
    }

    return numerador / denominador;
  }
  async createSequenceByLote(): Promise<void> {
    //Remover Lotes Repetidos
    const listCd006Unicos = this.removerRepetidos(this.listCd006Info);


    //Agrupar por Contrato
    this.listSequenceByLote = listCd006Unicos.reduce(function (r, a) {
      r[a.contrato_juridico] = r[a.contrato_juridico] || [];
      r[a.contrato_juridico].push(a);
      return r;
    }, Object.create(null));

    this.orderedListByContract.forEach(obj => {
      var key = obj.data.contrato_abreviado;

      if (!!this.listSequenceByLote[key]) {
        //calcular desvios
        this.fieldsSequenceByContract.forEach(fieldName => {
          /*if (fieldName.startsWith('peso_medio')) {
            this.listSequenceByLote[key][fieldName + '_sdev'] = this.calculoDesvioPadraoByLote(this.listSequenceByLote[key], fieldName);
          }*/

          if (fieldName.startsWith('peso_medio_ponderado')) {
            this.listSequenceByLote[key][fieldName + '_sdev'] = this.calcularPesoMedioPonderado(this.listSequenceByLote[key], fieldName);
          }

          if (fieldName.startsWith('total_defeitos_totais_ponderado')) {
            this.listSequenceByLote[key][fieldName + '_sdev'] = this.calcularDefeitosTotaisPonderado(this.listSequenceByLote[key], fieldName);
          }

          if (fieldName.startsWith('total_sequenciamento')) {
            this.listSequenceByLote[key][fieldName + '_sdev'] = this.calcularTotalSequenciamento();
          }
        })

        //Buscar peneira com Maior desvio
        const peneiraMaiorSdev = this.buscarCampoComMaiorDesvioByLote(this.listSequenceByLote[key]);

        //Buscar total de defeito ponderado minimo
        this.minDefeitosPondLote = this.buscarValorMinimoByLote(this.listSequenceByLote[key], 'total_defeitos_totais_ponderado');

        //Buscar total de peso medio ponderado minimo
        this.minPesoMedioPondLote = this.buscarValorMinimoByLote(this.listSequenceByLote[key], 'peso_medio_ponderado');

        //Agrupar por defeitos ponderados
        this.groupedListLotesByDefeitosPond = this.agruparPorLote(this.listSequenceByLote[key], 'total_defeitos_totais_ponderado');

        //OrdenarDentro dos grupos
        this.ordenarGruposByLote(this.groupedListLotesByDefeitosPond, 'peso_medio_' + peneiraMaiorSdev);

        //Marcar Variações aktas
        this.marcaAltaVariacao(this.orderedListByLote, key, 0);

        //Busca Fiaxas de Qualidade
        this.getFaixasDeQualidade(this.orderedMarkedListByLote);

        //Insere linhas de Sdev
        // this.insertSdevByLote(this.orderedMarkedListByLote, this.listSequenceByLote[key]);
      }
    })

    this.verificarTestesDadosFisilogicos(this.orderedMarkedListByLote);
    this.selectedLotesRegraSegragacao.length === 0 ? await this.montarSequenciaOtimizada() : await this.montarRegraSegregacao();
    this.ordenarSequenciaSugeridaContratos(this.tabelaLotesSequenciaOtimizada, this.tabelaLotesSegregadosSequenciaOtimizada);
    this.orderedListByContract.forEach(obj => {
      var key = obj.data.contrato_abreviado;
      if (!!this.listSequenceByLote[key] && this.tabelaLotesSequenciaOtimizada.length > 0)
        this.marcaAltaVariacao(this.tabelaLotesSequenciaOtimizada, key, 1);
    });
    this.dataSourceByLote = new MatTableDataSource(this.tabelaLotesSequenciaOtimizada);
  }

  async verificarTestesDadosFisilogicos(listaLotes: Array<any>): Promise<void> {
    let lotesSemResultadoQualidadeFisiologica = [];
    listaLotes.forEach(lotes => {
      this.listDadosFisiologicosUnicos.forEach(dadosFisiologicos => {
        if (lotes.data.lote_ds === dadosFisiologicos.lote) {
          const c1_germinacao_teste = dadosFisiologicos.c1_germinacao_teste;
          const c1_germinacao_reteste = dadosFisiologicos.c1_germinacao_reteste;
          const c1_vigor_teste = dadosFisiologicos.c1_vigor_teste;
          const c1_vigor_reteste = dadosFisiologicos.c1_vigor_reteste;
          const c2_germinacao_teste = dadosFisiologicos.c2_germinacao_teste;
          const c2_germinacao_reteste = dadosFisiologicos.c2_germinacao_reteste;
          const c2_vigor_teste = dadosFisiologicos.c2_vigor_teste;
          const c2_vigor_reteste = dadosFisiologicos.c2_vigor_reteste;
          const c3_germinacao_teste = dadosFisiologicos.c3_germinacao_teste;
          const c3_germinacao_reteste = dadosFisiologicos.c3_germinacao_reteste;
          const c3_vigor_teste = dadosFisiologicos.c3_vigor_teste;
          const c3_vigor_reteste = dadosFisiologicos.c3_vigor_reteste;
          const r1_germinacao_teste = dadosFisiologicos.r1_germinacao_teste;
          const r1_germinacao_reteste = dadosFisiologicos.r1_germinacao_reteste;
          const r1_vigor_teste = dadosFisiologicos.r1_vigor_teste;
          const r1_vigor_retest = dadosFisiologicos.r1_vigor_retest;
          const r2_germinacao_teste = dadosFisiologicos.r2_germinacao_teste;
          const r2_germinacao_reteste = dadosFisiologicos.r2_germinacao_reteste;
          const r2_vigor_teste = dadosFisiologicos.r2_vigor_teste;
          const r2_vigor_retest = dadosFisiologicos.r2_vigor_retest;
          const r3_germinacao_teste = dadosFisiologicos.r3_germinacao_teste;
          const r3_germinacao_reteste = dadosFisiologicos.r3_germinacao_reteste;
          const r3_vigor_teste = dadosFisiologicos.r3_vigor_teste;
          const r3_vigor_retest = dadosFisiologicos.r3_vigor_retest;

          if (c1_germinacao_teste === null && c1_germinacao_reteste === null && c1_vigor_teste === null && c1_vigor_reteste === null &&
            c2_germinacao_teste === null && c2_germinacao_reteste === null && c2_vigor_teste === null && c2_vigor_reteste === null &&
            c3_germinacao_teste === null && c3_germinacao_reteste === null && c3_vigor_teste === null && c3_vigor_reteste === null &&
            r1_germinacao_teste === null && r1_germinacao_reteste === null && r1_vigor_teste === null && r1_vigor_retest === null &&
            r2_germinacao_teste === null && r2_germinacao_reteste === null && r2_vigor_teste === null && r2_vigor_retest === null &&
            r3_germinacao_teste === null && r3_germinacao_reteste === null && r3_vigor_teste === null && r3_vigor_retest === null
          ) {
            this.enablelotesSemResultadoQualidadeFisiologica = true;

            lotesSemResultadoQualidadeFisiologica.push({ lote: lotes.data.lote_ds });
            this.lotesSemResultadoQualidadeFisiologica = lotesSemResultadoQualidadeFisiologica.map(item => `${item.lote}`).join(', ');
          }
          if (c1_germinacao_reteste !== null || c1_vigor_reteste !== null) {
            if (c1_germinacao_teste !== null && c1_vigor_teste !== null && c1_germinacao_reteste !== null && c1_vigor_reteste !== null) {
              {
                lotes['c1_teste'] = `Teste: G ${c1_germinacao_teste}% | V ${c1_vigor_teste}%
                                    Reteste: G ${c1_germinacao_reteste}% | V ${c1_vigor_reteste}%`
              };
            }
            else if (c1_germinacao_teste !== null && c1_vigor_teste !== null && c1_germinacao_reteste !== null && c1_vigor_reteste === null) {
              {
                lotes['c1_teste'] = `Teste: G ${c1_germinacao_teste}% | V ${c1_vigor_teste}%
                                    Reteste: G ${c1_germinacao_reteste}%`
              };
            }
            else if (c1_germinacao_teste !== null && c1_vigor_teste !== null && c1_germinacao_reteste === null && c1_vigor_reteste !== null) {
              {
                lotes['c1_teste'] = `Teste: G ${c1_germinacao_teste}% | V ${c1_vigor_teste}%
                                    Reteste: V ${c1_vigor_reteste}%`
              };
            }
            else if (c1_germinacao_teste !== null && c1_vigor_teste === null && c1_germinacao_reteste !== null && c1_vigor_reteste !== null) {
              {
                lotes['c1_teste'] = `Teste: G ${c1_germinacao_teste}%
                                    Reteste: G ${c1_germinacao_reteste}% | V ${c1_vigor_reteste}%`
              };
            }
            else if (c1_germinacao_teste === null && c1_vigor_teste !== null && c1_germinacao_reteste !== null && c1_vigor_reteste !== null) {
              {
                lotes['c1_teste'] = `Teste: V ${c1_vigor_teste}%
                                    Reteste: G ${c1_germinacao_reteste}% | V ${c1_vigor_reteste}%`
              };
            }
            else if (c1_germinacao_teste !== null && c1_vigor_teste === null && c1_germinacao_reteste !== null && c1_vigor_reteste === null) {
              {
                lotes['c1_teste'] = `Teste: G ${c1_germinacao_teste}%
                                    Reteste: G ${c1_germinacao_reteste}%`
              };
            }
            else if (c1_germinacao_teste === null && c1_vigor_teste !== null && c1_germinacao_reteste === null && c1_vigor_reteste !== null) {
              {
                lotes['c1_teste'] = `Teste: V ${c1_vigor_teste}%
                                    Reteste: V ${c1_vigor_reteste}%`
              };
            }
            else if (c1_germinacao_teste === null && c1_vigor_teste !== null && c1_germinacao_reteste !== null && c1_vigor_reteste === null) {
              {
                lotes['c1_teste'] = `Teste: V ${c1_vigor_teste}%
                                    Reteste: G ${c1_germinacao_reteste}%`
              };
            }
            else { lotes['c1_teste'] = `` };
          } else {
            if (c1_germinacao_teste !== null && c1_vigor_teste !== null) {
              { lotes['c1_teste'] = `G ${c1_germinacao_teste}% | V ${c1_vigor_teste}%` };
            }
            else if (c1_germinacao_teste !== null && c1_vigor_teste === null) {
              { lotes['c1_teste'] = `G ${c1_germinacao_teste}%` };
            }
            else if (c1_germinacao_teste === null && c1_vigor_teste !== null) {
              { lotes['c1_teste'] = `V ${c1_vigor_teste}%` };
            }
            else { lotes['c1_teste'] = `` };
          }

          if (c2_germinacao_reteste != null || c2_vigor_reteste != null) {
            if (c2_germinacao_teste !== null && c2_vigor_teste !== null && c2_germinacao_reteste !== null && c2_vigor_reteste !== null) {
              {
                lotes['c2_teste'] = `Teste: G ${c2_germinacao_teste}% | V ${c2_vigor_teste}%
                                    Reteste: G ${c2_germinacao_reteste}% | V ${c2_vigor_reteste}%`
              };
            }
            else if (c2_germinacao_teste !== null && c2_vigor_teste !== null && c2_germinacao_reteste !== null && c2_vigor_reteste === null) {
              {
                lotes['c2_teste'] = `Teste: G ${c2_germinacao_teste}% | V ${c2_vigor_teste}%
                                    Reteste: G ${c2_germinacao_reteste}%`
              };
            }
            else if (c2_germinacao_teste !== null && c2_vigor_teste !== null && c2_germinacao_reteste === null && c2_vigor_reteste !== null) {
              {
                lotes['c2_teste'] = `Teste: G ${c2_germinacao_teste}% | V ${c2_vigor_teste}%
                                    Reteste: V ${c2_vigor_reteste}%`
              };
            }
            else if (c2_germinacao_teste !== null && c2_vigor_teste === null && c2_germinacao_reteste !== null && c2_vigor_reteste !== null) {
              {
                lotes['c2_teste'] = `Teste: G ${c2_germinacao_teste}%
                                    Reteste: G ${c2_germinacao_reteste}% | V ${c2_vigor_reteste}%`
              };
            }
            else if (c2_germinacao_teste === null && c2_vigor_teste !== null && c2_germinacao_reteste !== null && c2_vigor_reteste !== null) {
              {
                lotes['c2_teste'] = `Teste: V ${c2_vigor_teste}%
                                    Reteste: G ${c2_germinacao_reteste}% | V ${c2_vigor_reteste}%`
              };
            }
            else if (c2_germinacao_teste !== null && c2_vigor_teste === null && c2_germinacao_reteste !== null && c2_vigor_reteste === null) {
              {
                lotes['c2_teste'] = `Teste: G ${c2_germinacao_teste}%
                                    Reteste: G ${c2_germinacao_reteste}%`
              };
            }
            else if (c2_germinacao_teste === null && c2_vigor_teste !== null && c2_germinacao_reteste === null && c2_vigor_reteste !== null) {
              {
                lotes['c2_teste'] = `Teste: V ${c2_vigor_teste}%
                                    Reteste: V ${c2_vigor_reteste}%`
              };
            }
            else if (c2_germinacao_teste === null && c2_vigor_teste !== null && c2_germinacao_reteste !== null && c2_vigor_reteste === null) {
              {
                lotes['c2_teste'] = `Teste: V ${c2_vigor_teste}%
                                    Reteste: G ${c2_germinacao_reteste}%`
              };
            }
            else { lotes['c2_teste'] = `` };
          } else {
            if (c2_germinacao_teste !== null && c2_vigor_teste !== null) {
              { lotes['c2_teste'] = `G ${c2_germinacao_teste}% | V ${c2_vigor_teste}%` };
            }
            else if (c2_germinacao_teste !== null && c2_vigor_teste === null) {
              { lotes['c2_teste'] = `G ${c2_germinacao_teste}%` };
            }
            else if (c2_germinacao_teste === null && c2_vigor_teste !== null) {
              { lotes['c2_teste'] = `V ${c2_vigor_teste}%` };
            }
            else { lotes['c2_teste'] = `` };
          }

          if (c3_germinacao_reteste != null || c3_vigor_reteste != null) {
            if (c3_germinacao_teste !== null && c3_vigor_teste !== null && c3_germinacao_reteste !== null && c3_vigor_reteste !== null) {
              {
                lotes['c3_teste'] = `Teste: G ${c3_germinacao_teste}% | V ${c3_vigor_teste}%
                                    Reteste: G ${c3_germinacao_reteste}% | V ${c3_vigor_reteste}%`
              };
            }
            else if (c3_germinacao_teste !== null && c3_vigor_teste !== null && c3_germinacao_reteste !== null && c3_vigor_reteste === null) {
              {
                lotes['c3_teste'] = `Teste: G ${c3_germinacao_teste}% | V ${c3_vigor_teste}%
                                    Reteste: G ${c3_germinacao_reteste}%`
              };
            }
            else if (c3_germinacao_teste !== null && c3_vigor_teste !== null && c3_germinacao_reteste === null && c3_vigor_reteste !== null) {
              {
                lotes['c3_teste'] = `Teste: G ${c3_germinacao_teste}% | V ${c3_vigor_teste}%
                                    Reteste: V ${c3_vigor_reteste}%`
              };
            }
            else if (c3_germinacao_teste !== null && c3_vigor_teste === null && c3_germinacao_reteste !== null && c3_vigor_reteste !== null) {
              {
                lotes['c3_teste'] = `Teste: G ${c3_germinacao_teste}%
                                    Reteste: G ${c3_germinacao_reteste}% | V ${c3_vigor_reteste}%`
              };
            }
            else if (c3_germinacao_teste === null && c3_vigor_teste !== null && c3_germinacao_reteste !== null && c3_vigor_reteste !== null) {
              {
                lotes['c3_teste'] = `Teste: V ${c3_vigor_teste}%
                                    Reteste: G ${c3_germinacao_reteste}% | V ${c3_vigor_reteste}%`
              };
            }
            else if (c3_germinacao_teste !== null && c3_vigor_teste === null && c3_germinacao_reteste !== null && c3_vigor_reteste === null) {
              {
                lotes['c3_teste'] = `Teste: G ${c3_germinacao_teste}%
                                    Reteste: G ${c3_germinacao_reteste}%`
              };
            }
            else if (c3_germinacao_teste === null && c3_vigor_teste !== null && c3_germinacao_reteste === null && c3_vigor_reteste !== null) {
              {
                lotes['c3_teste'] = `Teste: V ${c3_vigor_teste}%
                                    Reteste: V ${c3_vigor_reteste}%`
              };
            }
            else if (c3_germinacao_teste === null && c3_vigor_teste !== null && c3_germinacao_reteste !== null && c3_vigor_reteste === null) {
              {
                lotes['c3_teste'] = `Teste: V ${c3_vigor_teste}%
                                    Reteste: G ${c3_germinacao_reteste}%`
              };
            }
            else { lotes['c3_teste'] = `` };
          } else {
            if (c3_germinacao_teste !== null && c3_vigor_teste !== null) {
              { lotes['c3_teste'] = `G ${c3_germinacao_teste}% | V ${c3_vigor_teste}%` };
            }
            else if (c3_germinacao_teste !== null && c3_vigor_teste === null) {
              { lotes['c3_teste'] = `G ${c3_germinacao_teste}%` };
            }
            else if (c3_germinacao_teste === null && c3_vigor_teste !== null) {
              { lotes['c3_teste'] = `V ${c3_vigor_teste}%` };
            }
            else { lotes['c3_teste'] = `` };
          }

          if (r1_germinacao_reteste != null || r1_vigor_retest != null) {
            if (r1_germinacao_teste !== null && r1_vigor_teste !== null && r1_germinacao_reteste !== null && r1_vigor_retest !== null) {
              {
                lotes['r1_teste'] = `Teste: G ${r1_germinacao_teste}% | V ${r1_vigor_teste}%
                                    Reteste: G ${r1_germinacao_reteste}% | V ${r1_vigor_retest}%`
              };
            }
            else if (r1_germinacao_teste !== null && r1_vigor_teste !== null && r1_germinacao_reteste !== null && r1_vigor_retest === null) {
              {
                lotes['r1_teste'] = `Teste: G ${r1_germinacao_teste}% | V ${r1_vigor_teste}%
                                    Reteste: G ${r1_germinacao_reteste}%`
              };
            }
            else if (r1_germinacao_teste !== null && r1_vigor_teste !== null && r1_germinacao_reteste === null && r1_vigor_retest !== null) {
              {
                lotes['r1_teste'] = `Teste: G ${r1_germinacao_teste}% | V ${r1_vigor_teste}%
                                    Reteste: V ${r1_vigor_retest}%`
              };
            }
            else if (r1_germinacao_teste !== null && r1_vigor_teste === null && r1_germinacao_reteste !== null && r1_vigor_retest !== null) {
              {
                lotes['r1_teste'] = `Teste: G ${r1_germinacao_teste}%
                                    Reteste: G ${r1_germinacao_reteste}% | V ${r1_vigor_retest}%`
              };
            }
            else if (r1_germinacao_teste === null && r1_vigor_teste !== null && r1_germinacao_reteste !== null && r1_vigor_retest !== null) {
              {
                lotes['r1_teste'] = `Teste: V ${r1_vigor_teste}%
                                    Reteste: G ${r1_germinacao_reteste}% | V ${r1_vigor_retest}%`
              };
            }
            else if (r1_germinacao_teste !== null && r1_vigor_teste === null && r1_germinacao_reteste !== null && r1_vigor_retest === null) {
              {
                lotes['r1_teste'] = `Teste: G ${r1_germinacao_teste}%
                                    Reteste: G ${r1_germinacao_reteste}%`
              };
            }
            else if (r1_germinacao_teste === null && r1_vigor_teste !== null && r1_germinacao_reteste === null && r1_vigor_retest !== null) {
              {
                lotes['r1_teste'] = `Teste: V ${r1_vigor_teste}%
                                    Reteste: V ${r1_vigor_retest}%`
              };
            }
            else if (r1_germinacao_teste === null && r1_vigor_teste !== null && r1_germinacao_reteste !== null && r1_vigor_retest === null) {
              {
                lotes['r1_teste'] = `Teste: V ${r1_vigor_teste}%
                                    Reteste: G ${r1_germinacao_reteste}%`
              };
            }
            else { lotes['r1_teste'] = `` };
          } else {
            if (r1_germinacao_teste !== null && r1_vigor_teste !== null) {
              { lotes['r1_teste'] = `G ${r1_germinacao_teste}% | V ${r1_vigor_teste}%` };
            }
            else if (r1_germinacao_teste !== null && r1_vigor_teste === null) {
              { lotes['r1_teste'] = `G ${r1_germinacao_teste}%` };
            }
            else if (r1_germinacao_teste === null && r1_vigor_teste !== null) {
              { lotes['r1_teste'] = `V ${r1_vigor_teste}%` };
            }
            else { lotes['r1_teste'] = `` };
          }

          if (r2_germinacao_reteste != null || r2_vigor_retest != null) {
            if (r2_germinacao_teste !== null && r2_vigor_teste !== null && r2_germinacao_reteste !== null && r2_vigor_retest !== null) {
              {
                lotes['r2_teste'] = `Teste: G ${r2_germinacao_teste}% | V ${r2_vigor_teste}%
                                    Reteste: G ${r2_germinacao_reteste}% | V ${r2_vigor_retest}%`
              };
            }
            else if (r2_germinacao_teste !== null && r2_vigor_teste !== null && r2_germinacao_reteste !== null && r2_vigor_retest === null) {
              {
                lotes['r2_teste'] = `Teste: G ${r2_germinacao_teste}% | V ${r2_vigor_teste}%
                                    Reteste: G ${r2_germinacao_reteste}%`
              };
            }
            else if (r2_germinacao_teste !== null && r2_vigor_teste !== null && r2_germinacao_reteste === null && r2_vigor_retest !== null) {
              {
                lotes['r2_teste'] = `Teste: G ${r2_germinacao_teste}% | V ${r2_vigor_teste}%
                                    Reteste: V ${r2_vigor_retest}%`
              };
            }
            else if (r2_germinacao_teste !== null && r2_vigor_teste === null && r2_germinacao_reteste !== null && r2_vigor_retest !== null) {
              {
                lotes['r2_teste'] = `Teste: G ${r2_germinacao_teste}%
                                    Reteste: G ${r2_germinacao_reteste}% | V ${r2_vigor_retest}%`
              };
            }
            else if (r2_germinacao_teste === null && r2_vigor_teste !== null && r2_germinacao_reteste !== null && r2_vigor_retest !== null) {
              {
                lotes['r2_teste'] = `Teste: V ${r2_vigor_teste}%
                                    Reteste: G ${r2_germinacao_reteste}% | V ${r2_vigor_retest}%`
              };
            }
            else if (r2_germinacao_teste !== null && r2_vigor_teste === null && r2_germinacao_reteste !== null && r2_vigor_retest === null) {
              {
                lotes['r2_teste'] = `Teste: G ${r2_germinacao_teste}%
                                    Reteste: G ${r2_germinacao_reteste}%`
              };
            }
            else if (r2_germinacao_teste === null && r2_vigor_teste !== null && r2_germinacao_reteste === null && r2_vigor_retest !== null) {
              {
                lotes['r2_teste'] = `Teste: V ${r2_vigor_teste}%
                                    Reteste: V ${r2_vigor_retest}%`
              };
            }
            else if (r2_germinacao_teste === null && r2_vigor_teste !== null && r2_germinacao_reteste !== null && r2_vigor_retest === null) {
              {
                lotes['r2_teste'] = `Teste: V ${r2_vigor_teste}%
                                    Reteste: G ${r2_germinacao_reteste}%`
              };
            }
            else { lotes['r2_teste'] = `` };
          } else {
            if (r2_germinacao_teste !== null && r2_vigor_teste !== null) {
              { lotes['r2_teste'] = `G ${r2_germinacao_teste}% | V ${r2_vigor_teste}%` };
            }
            else if (r2_germinacao_teste !== null && r2_vigor_teste === null) {
              { lotes['r2_teste'] = `G ${r2_germinacao_teste}%` };
            }
            else if (r2_germinacao_teste === null && r2_vigor_teste !== null) {
              { lotes['r2_teste'] = `V ${r2_vigor_teste}%` };
            }
            else { lotes['r2_teste'] = `` };
          }

          if (r3_germinacao_reteste != null || r3_vigor_retest != null) {
            if (r3_germinacao_teste !== null && r3_vigor_teste !== null && r3_germinacao_reteste !== null && r3_vigor_retest !== null) {
              {
                lotes['r3_teste'] = `Teste: G ${r3_germinacao_teste}% | V ${r3_vigor_teste}%
                                    Reteste: G ${r3_germinacao_reteste}% | V ${r3_vigor_retest}%`
              };
            }
            else if (r3_germinacao_teste !== null && r3_vigor_teste !== null && r3_germinacao_reteste !== null && r3_vigor_retest === null) {
              {
                lotes['r3_teste'] = `Teste: G ${r3_germinacao_teste}% | V ${r3_vigor_teste}%
                                    Reteste: G ${r3_germinacao_reteste}%`
              };
            }
            else if (r3_germinacao_teste !== null && r3_vigor_teste !== null && r3_germinacao_reteste === null && r3_vigor_retest !== null) {
              {
                lotes['r3_teste'] = `Teste: G ${r3_germinacao_teste}% | V ${r3_vigor_teste}%
                                    Reteste: V ${r3_vigor_retest}%`
              };
            }
            else if (r3_germinacao_teste !== null && r3_vigor_teste === null && r3_germinacao_reteste !== null && r3_vigor_retest !== null) {
              {
                lotes['r3_teste'] = `Teste: G ${r3_germinacao_teste}%
                                    Reteste: G ${r3_germinacao_reteste}% | V ${r3_vigor_retest}%`
              };
            }
            else if (r3_germinacao_teste === null && r3_vigor_teste !== null && r3_germinacao_reteste !== null && r3_vigor_retest !== null) {
              {
                lotes['r3_teste'] = `Teste: V ${r3_vigor_teste}%
                                    Reteste: G ${r3_germinacao_reteste}% | V ${r3_vigor_retest}%`
              };
            }
            else if (r3_germinacao_teste !== null && r3_vigor_teste === null && r3_germinacao_reteste !== null && r3_vigor_retest === null) {
              {
                lotes['r3_teste'] = `Teste: G ${r3_germinacao_teste}%
                                    Reteste: G ${r3_germinacao_reteste}%`
              };
            }
            else if (r3_germinacao_teste === null && r3_vigor_teste !== null && r3_germinacao_reteste === null && r3_vigor_retest !== null) {
              {
                lotes['r3_teste'] = `Teste: V ${r3_vigor_teste}%
                                    Reteste: V ${r3_vigor_retest}%`
              };
            }
            else if (r3_germinacao_teste === null && r3_vigor_teste !== null && r3_germinacao_reteste !== null && r3_vigor_retest === null) {
              {
                lotes['r3_teste'] = `Teste: V ${r3_vigor_teste}%
                                    Reteste: G ${r3_germinacao_reteste}%`
              };
            }
            else { lotes['r3_teste'] = `` };
          } else {
            if (r3_germinacao_teste !== null && r3_vigor_teste !== null) {
              { lotes['r3_teste'] = `G ${r3_germinacao_teste}% | V ${r3_vigor_teste}%` };
            }
            else if (r3_germinacao_teste !== null && r3_vigor_teste === null) {
              { lotes['r3_teste'] = `G ${r3_germinacao_teste}%` };
            }
            else if (r3_germinacao_teste === null && r3_vigor_teste !== null) {
              { lotes['r3_teste'] = `V ${r3_vigor_teste}%` };
            }
            else { lotes['r3_teste'] = `` };
          }

          if (c1_germinacao_reteste === null || c1_vigor_reteste === null) {
            if ((c1_germinacao_teste < 90 && c1_germinacao_teste !== null) || (c1_vigor_teste < 85 && c1_vigor_teste !== null)
            ) {
              { lotes['c1_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['c1_reprovado'] = `N` };
            }
          } else {
            if ((c1_germinacao_reteste < 90 && c1_germinacao_reteste !== null) || (c1_vigor_reteste < 85 && c1_vigor_reteste !== null)
            ) {
              { lotes['c1_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['c1_reprovado'] = `N` };
            }
          }

          if (c2_germinacao_reteste === null || c2_vigor_reteste === null) {
            if ((c2_germinacao_teste < 90 && c2_germinacao_teste !== null) || (c2_vigor_teste < 85 && c2_vigor_teste !== null)) {
              { lotes['c2_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['c2_reprovado'] = `N` };
            }
          } else {
            if ((c2_germinacao_reteste < 90 && c2_germinacao_reteste !== null) || (c2_vigor_reteste < 85 && c2_vigor_reteste !== null)
            ) {
              { lotes['c2_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['c2_reprovado'] = `N` };
            }
          }

          if (c3_germinacao_reteste === null || c3_vigor_reteste === null) {
            if ((c3_germinacao_teste < 90 && c3_germinacao_teste !== null) || (c3_vigor_teste < 85 && c3_vigor_teste !== null)) {
              { lotes['c3_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['c3_reprovado'] = `N` };
            }
          } else {
            if ((c3_germinacao_reteste < 90 && c3_germinacao_reteste !== null) || (c3_vigor_reteste < 85 && c3_vigor_reteste !== null)
            ) {
              { lotes['c3_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['c3_reprovado'] = `N` };
            }
          }

          if (r1_germinacao_reteste === null || r1_vigor_retest === null) {
            if ((r1_germinacao_teste < 90 && r1_germinacao_teste !== null) || (r1_vigor_teste < 85 && r1_vigor_teste !== null)) {
              { lotes['r1_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['r1_reprovado'] = `N` };
            }
          } else {
            if ((r1_germinacao_reteste < 90 && r1_germinacao_reteste !== null) || (r1_vigor_retest < 85 && r1_vigor_retest !== null)
            ) {
              { lotes['r1_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['r1_reprovado'] = `N` };
            }
          }

          if (r2_germinacao_reteste === null || r2_vigor_retest === null) {
            if ((r2_germinacao_teste < 90 && r2_germinacao_teste !== null) || (r2_vigor_teste < 85 && r2_vigor_teste !== null)) {
              { lotes['r2_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['r2_reprovado'] = `N` };
            }
          } else {
            if ((r2_germinacao_reteste < 90 && r2_germinacao_reteste !== null) || (r2_vigor_retest < 85 && r2_vigor_retest !== null)
            ) {
              { lotes['r2_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['r2_reprovado'] = `N` };
            }
          }

          if (r3_germinacao_reteste === null || r3_vigor_retest === null) {
            if ((r3_germinacao_teste < 90 && r3_germinacao_teste !== null) || (r3_vigor_teste < 85 && r3_vigor_teste !== null)) {
              { lotes['r3_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['r3_reprovado'] = `N` };
            }
          } else {
            if ((r3_germinacao_reteste < 90 && r3_germinacao_reteste !== null) || (r3_vigor_retest < 85 && r3_vigor_retest !== null)
            ) {
              { lotes['r3_reprovado'] = `S` };
              this.enablePeneiraReprovada = true;
            } else {
              { lotes['r3_reprovado'] = `N` };
            }
          }

          this.isMensagemTesteDadosFisiologicos = true;
        } else {
          this.isMensagemTesteDadosFisiologicos = false;
        }
      });
    });
  }

  formatCellPeneirasReprovadas(value: any, field: string): string {
    var classStr = '';

    if (value[field] === "S") {
      classStr += 'peneira-reprovada';
    }
    else classStr += '';

    return classStr;
  }

  async gerarSequenciaOtimizada(listaLotes: Array<any>, listaLotesSequenciaOtimizada: Array<any>): Promise<void> {
    let sequencia;
    var tabela = [];
    const ListByLote = [...listaLotes];
    sequencia = this.logicSequenceStrategyService.montarSequenciaOtimizada(ListByLote, "nao-segregado");
    if (this.selectedPrioridadeSequenciamento === 2)
      sequencia.reverse();
    tabela.push(sequencia);
    for (var i = 0; i < tabela.length; i++) {
      for (var j = 0; j < tabela[i].length; j++)
        listaLotesSequenciaOtimizada.push(tabela[i][j]);
    }
  }

  async montarSequenciaOtimizada(): Promise<void> {
    await this.gerarSequenciaOtimizada(this.orderedMarkedListByLote, this.tabelaLotesSequenciaOtimizada);
  }

  async montarRegraSegregacao(): Promise<void> {
    await this.criarListaLotesNaoSegregados();
    await this.criarListaLotesSegregados();
  }

  async criarListaLotesNaoSegregados(): Promise<void> {
    var tabelaNaoSegregado = [];
    tabelaNaoSegregado = this.listCd006Info;
    for (var i = 0; i < this.listCd006Info.length; i++)
      tabelaNaoSegregado = tabelaNaoSegregado.filter(objeto => objeto.lote_ds !== this.selectedLotesRegraSegragacao[i]);
    await this.agruparPorContratos(tabelaNaoSegregado);
    var orderedMarkedListByLoteSegregado = [];
    orderedMarkedListByLoteSegregado = this.orderedMarkedListByLoteSegregado;
    for (var i = 0; i < this.selectedLotesRegraSegragacao.length; i++) {
      orderedMarkedListByLoteSegregado = orderedMarkedListByLoteSegregado.filter(objeto => objeto.data.lote_ds !== this.selectedLotesRegraSegragacao[i]);
    }
    this.orderedMarkedListByLoteSegregado = orderedMarkedListByLoteSegregado;
    await this.gerarSequenciaOtimizada(this.orderedMarkedListByLoteSegregado, this.tabelaLotesSequenciaOtimizada);
  }

  async criarListaLotesSegregados(): Promise<void> {
    var orderedMarkedListByLoteSegregado = [];
    orderedMarkedListByLoteSegregado = this.orderedMarkedListByLoteNaoSegregado;
    orderedMarkedListByLoteSegregado = this.orderedMarkedListByLoteNaoSegregado.filter(obj => this.selectedLotesRegraSegragacao.includes(obj.data.lote_ds));
    this.orderedMarkedListByLoteNaoSegregado = orderedMarkedListByLoteSegregado;
    await this.gerarSequenciaOtimizada(this.orderedMarkedListByLoteNaoSegregado, this.tabelaLotesSegregadosSequenciaOtimizada);
    await this.organizarListaLotesSegregadosPorFaixa();
  }

  async organizarListaLotesSegregadosPorFaixa(): Promise<void> {
    let sequenciaPorFaixaAux, sequenciaPorFaixa, sequenciaFaixasAzulClaro, sequenciaFaixasAzulCampo, sequenciaFaixasAzulPlanta, sequenciaFaixasAzulEscuro, sequenciaFaixasVermelhas, sequenciaSemFaixasVermelhas;

    for (var i = 0; i < this.tabelaLotesSegregadosSequenciaOtimizada.length; i++) {
      this.formatSiloCellTextColor(this.tabelaLotesSegregadosSequenciaOtimizada[i], "TS");
    }
    sequenciaFaixasVermelhas = this.tabelaFaixasVermelhas;

    if (this.selectedMisturarTonsAzul === "S") {
      this.tabelaFaixasVermelhas.forEach(element => { element['grupo_faixa'] = 4; });
      this.tabelaSemFaixasVermelhas.forEach(element => { element['grupo_faixa'] = 5; });

      sequenciaPorFaixaAux = this.tabelaFaixas
        .concat(
          this.tabelaSemFaixasVermelhas,
          this.tabelaFaixasVermelhas);

      sequenciaPorFaixa = this.logicSequenceStrategyService.montarSequenciaOtimizada(sequenciaPorFaixaAux, "segregado");
    }
    else if (this.selectedMisturarTonsAzul === "N") {
      sequenciaFaixasAzulClaro = this.tabelaFaixasAzulClaro;
      sequenciaFaixasAzulCampo = this.tabelaFaixasAzulCampo;
      sequenciaFaixasAzulPlanta = this.tabelaFaixasAzulPlanta;
      sequenciaFaixasAzulEscuro = this.tabelaFaixasAzulEscuro;

      sequenciaPorFaixaAux = this.tabelaFaixas
        .concat(
          sequenciaFaixasAzulClaro,
          sequenciaFaixasAzulCampo,
          sequenciaFaixasAzulPlanta,
          sequenciaFaixasAzulEscuro,
          sequenciaFaixasVermelhas);

      sequenciaPorFaixa = this.logicSequenceStrategyService.montarSequenciaOtimizada(sequenciaPorFaixaAux, "segregado");
    }

    if (this.selectedPrioridadeSequenciamento === 2)
      sequenciaPorFaixa.reverse();

    this.orderedListByContract.forEach(obj => {
      var key = obj.data.contrato_abreviado;
      if (!!this.listSequenceByLote[key])
        this.marcaAltaVariacao(sequenciaPorFaixa, key, 1);
    });
    this.dataSourceByLoteSegregado = new MatTableDataSource(sequenciaPorFaixa);
  }

  async removerDuplicados(array: Array<any>, propriedade: string): Promise<Array<any>> {
    return array.filter((obj, index, self) =>
      index === self.findIndex((t) => (
        t.data[propriedade] === obj.data[propriedade]
      ))
    );
  }

  async verificarOrdemDosContratosDosLotesSegregados(listaLotes: Array<any>): Promise<void> {
    var contratos = [];
    const ListByLote = [...listaLotes];

    ListByLote.forEach(obj => {
      var key = obj.data.contrato_juridico;
      contratos.push(key);
    })
    const contratosUnicos = [...new Set(contratos)];
    this.ordemContratos = contratosUnicos;
  }

  async agruparPorContratos(array: Array<any>): Promise<void> {
    //Remover Lotes Repetidos
    const listCd006Unicos = this.removerRepetidos(array);

    //Agrupar por Contrato
    var listSequenceByLote = [];
    listSequenceByLote = listCd006Unicos.reduce(function (r, a) {
      r[a.contrato_juridico] = r[a.contrato_juridico] || [];
      r[a.contrato_juridico].push(a);
      return r;
    }, Object.create(null));

    listCd006Unicos.forEach(obj => {
      var key = obj.contrato_juridico;

    })

    var contratos = [];
    listCd006Unicos.forEach(obj => {
      var key = obj.contrato_juridico;
      contratos.push(key);
    })
    const contratosUnicos = [...new Set(contratos)];
    this.listContratos = contratosUnicos;
    this.listContratos.length === 1 ? this.isUnicoContrato = true : this.isUnicoContrato = false;
  }

  insertSdevByLote(array: Array<any>, arraySdevs: Array<any>) {
    const filteredArray = array.filter(elem => elem.data.contrato_juridico === arraySdevs[0].contrato_juridico)
    this.orderedListByLoteWithSdev = this.orderedListByLoteWithSdev.concat(filteredArray);

    if (filteredArray.length > 0) {
      var objSdev = { data: {} };
      for (let key of Object.keys(filteredArray[0].data)) {
        switch (key) {
          case 'peso_medio_c1':
            objSdev.data[key] = arraySdevs['peso_medio_c1_sdev'];

            break;

          case 'peso_medio_c2':
            objSdev.data[key] = arraySdevs['peso_medio_c2_sdev'];

            break;

          case 'peso_medio_c3':
            objSdev.data[key] = arraySdevs['peso_medio_c3_sdev'];

            break;

          case 'peso_medio_r1':
            objSdev.data[key] = arraySdevs['peso_medio_r1_sdev'];

            break;

          case 'peso_medio_r2':
            objSdev.data[key] = arraySdevs['peso_medio_r2_sdev'];

            break;

          case 'peso_medio_r3':
            objSdev.data[key] = arraySdevs['peso_medio_r3_sdev'];

            break;

          case 'peso_medio_r3':
            objSdev.data[key] = arraySdevs['peso_medio_r3_sdev'];

            break;

          case 'peneira_max_sdev':
            objSdev.data[key] = filteredArray[0].data['peneira_max_sdev'];

            break;

          case 'g2_g3_total':
            objSdev.data[key] = 'Sdev';

            break;

          case 'peso_medio_ponderado':
            objSdev.data[key] = arraySdevs['peso_medio_ponderado_sdev'];

            break;

          default:
            objSdev.data[key] = null
            break;
        }
      }
    }
    this.orderedListByLoteWithSdev.push(objSdev);
  }

  async calcularTubulares(array: Array<any>, tubularSite: any): Promise<void> {
    for (let i = 0; i < array.length; i++) {
      let listaValoresVazaoPeneira: number[] = [];
      const c1_prc = array[i].data.c1_prc / 100;
      const c2_prc = array[i].data.c2_prc / 100;
      const c3_prc = array[i].data.c3_prc / 100;
      const r1_prc = array[i].data.r1_prc / 100;
      const r2_prc = array[i].data.r2_prc / 100;
      const r3_prc = array[i].data.r3_prc / 100;
      const volume_ds = array[i].data.soma_lote_total;
      const lote_ds = array[i].data.lote_ds;

      if (c1_prc >= 1.5 * r1_prc)
        this.vazaoTonPeneira13ob = 0.55;
      else
        this.vazaoTonPeneira13ob = 0.5;
      if (c2_prc >= 1.5 * r2_prc)
        this.vazaoTonPeneira125ob = 0.55;
      else
        this.vazaoTonPeneira125ob = 0.5;
      if (c3_prc >= 1.5 * r3_prc)
        this.vazaoTonPeneira12ob = 0.55;
      else
        this.vazaoTonPeneira12ob = 0.5;

      if (tubularSite !== undefined) {
        const valorTubularDisponivelPeneira21 = tubularSite.peneira_21;
        const valorTubularDisponivelPeneira19 = tubularSite.peneira_19;
        const valorTubularDisponivelPeneira16 = tubularSite.peneira_16;
        const valorTubularDisponivelPeneira13ob = tubularSite.peneira_13ob;
        const valorTubularDisponivelPeneira125ob = tubularSite.peneira_125ob;
        const valorTubularDisponivelPeneira12ob = tubularSite.peneira_12ob;
        // Valores de material passando em cada peneira
        const prcValorMaterialPeneira21 = c1_prc + c2_prc + c3_prc + r1_prc + r2_prc + r3_prc;
        const prcValorMaterialPeneira19 = c2_prc + r2_prc + c3_prc + r3_prc;
        const prcValorMaterialPeneira16 = c3_prc + r3_prc;
        const prcValorMaterialPeneira13ob = c1_prc + r1_prc;
        const prcValorMaterialPeneira125ob = c2_prc + r2_prc;
        const prcValorMaterialPeneira12ob = c3_prc + r3_prc;
        const valorMaterialPeneira21 = prcValorMaterialPeneira21 / 100;
        const valorMaterialPeneira19 = prcValorMaterialPeneira19 / 100;
        const valorMaterialPeneira16 = prcValorMaterialPeneira16 / 100;
        const valorMaterialPeneira13ob = prcValorMaterialPeneira13ob / 100;
        const valorMaterialPeneira125ob = prcValorMaterialPeneira125ob / 100;
        const valorMaterialPeneira12ob = prcValorMaterialPeneira12ob / 100;
        // Vazão de cada peneira
        const valorVazaoPeneira21 = valorTubularDisponivelPeneira21 / (valorMaterialPeneira21 / this.vazaoTonPeneira21);
        const valorVazaoPeneira19 = valorTubularDisponivelPeneira19 / (valorMaterialPeneira19 / this.vazaoTonPeneira19);
        const valorVazaoPeneira16 = valorTubularDisponivelPeneira16 / (valorMaterialPeneira16 / this.vazaoTonPeneira16);
        const valorVazaoPeneira13ob = valorTubularDisponivelPeneira13ob / (valorMaterialPeneira13ob / this.vazaoTonPeneira13ob);
        const valorVazaoPeneira125ob = valorTubularDisponivelPeneira125ob / (valorMaterialPeneira125ob / this.vazaoTonPeneira125ob);
        const valorVazaoPeneira12ob = valorTubularDisponivelPeneira12ob / (valorMaterialPeneira12ob / this.vazaoTonPeneira12ob);
        listaValoresVazaoPeneira.push(valorVazaoPeneira21);
        listaValoresVazaoPeneira.push(valorVazaoPeneira19);
        listaValoresVazaoPeneira.push(valorVazaoPeneira16);
        listaValoresVazaoPeneira.push(valorVazaoPeneira13ob);
        listaValoresVazaoPeneira.push(valorVazaoPeneira125ob);
        listaValoresVazaoPeneira.push(valorVazaoPeneira12ob);
        // Menor valor de vazão de cada peneira
        const valorVazaoPeneira = Math.min(...listaValoresVazaoPeneira);
        // Tubulares
        const valoresTubulares21 = valorMaterialPeneira21 * valorVazaoPeneira;
        const valoresTubulares19 = valorMaterialPeneira19 * valorVazaoPeneira;
        const valoresTubulares16 = valorMaterialPeneira16 * valorVazaoPeneira;
        const valoresTubulares13ob = valorMaterialPeneira13ob * valorVazaoPeneira;
        const valoresTubulares125ob = valorMaterialPeneira125ob * valorVazaoPeneira;
        const valoresTubulares12ob = valorMaterialPeneira12ob * valorVazaoPeneira;
        // Tubulares Necessários, considerando a vazão da peneira
        const tubularesNecessariosPeneira21 = valoresTubulares21 / this.vazaoTonPeneira21;
        const tubularesNecessariosPeneira19 = valoresTubulares19 / this.vazaoTonPeneira19;
        const tubularesNecessariosPeneira16 = valoresTubulares16 / this.vazaoTonPeneira16;
        const tubularesNecessariosPeneira13ob = valoresTubulares13ob / this.vazaoTonPeneira13ob;
        const tubularesNecessariosPeneira125ob = valoresTubulares125ob / this.vazaoTonPeneira125ob;
        const tubularesNecessariosPeneira12ob = valoresTubulares12ob / this.vazaoTonPeneira12ob;
        const tubularesNecessariosPeneira21Arredondado = Math.ceil(tubularesNecessariosPeneira21);
        const tubularesNecessariosPeneira19Arredondado = Math.ceil(tubularesNecessariosPeneira19);
        const tubularesNecessariosPeneira16Arredondado = Math.ceil(tubularesNecessariosPeneira16);
        const tubularesNecessariosPeneira13obArredondado = Math.ceil(tubularesNecessariosPeneira13ob);
        const tubularesNecessariosPeneira125obArredondado = Math.ceil(tubularesNecessariosPeneira125ob);
        const tubularesNecessariosPeneira12obArredondado = Math.ceil(tubularesNecessariosPeneira12ob);

        const novalistLotesTubulares: TubularesModel = {
          lote_ds: array[i].data.lote_ds,
          soma_lote_total: array[i].data.soma_lote_total,
          valoresArredondadosTubularesNecessariosPeneira21: tubularesNecessariosPeneira21Arredondado,
          valoresArredondadosTubularesNecessariosPeneira19: tubularesNecessariosPeneira19Arredondado,
          valoresArredondadosTubularesNecessariosPeneira16: tubularesNecessariosPeneira16Arredondado,
          valoresArredondadosTubularesNecessariosPeneira13ob: tubularesNecessariosPeneira13obArredondado,
          valoresArredondadosTubularesNecessariosPeneira125ob: tubularesNecessariosPeneira125obArredondado,
          valoresArredondadosTubularesNecessariosPeneira12ob: tubularesNecessariosPeneira12obArredondado
        };
        this.listLotesTubulares.push(novalistLotesTubulares);
        let somaLoteTotal = this.listLotesTubulares.reduce((acc, curr) => acc + curr.soma_lote_total, 0);
        let media21 = this.listLotesTubulares.reduce((acc, curr) => acc + curr.valoresArredondadosTubularesNecessariosPeneira21 * curr.soma_lote_total, 0);
        let media19 = this.listLotesTubulares.reduce((acc, curr) => acc + curr.valoresArredondadosTubularesNecessariosPeneira19 * curr.soma_lote_total, 0);
        let media16 = this.listLotesTubulares.reduce((acc, curr) => acc + curr.valoresArredondadosTubularesNecessariosPeneira16 * curr.soma_lote_total, 0);
        let media13ob = this.listLotesTubulares.reduce((acc, curr) => acc + curr.valoresArredondadosTubularesNecessariosPeneira13ob * curr.soma_lote_total, 0);
        let media125ob = this.listLotesTubulares.reduce((acc, curr) => acc + curr.valoresArredondadosTubularesNecessariosPeneira125ob * curr.soma_lote_total, 0);
        let media12ob = this.listLotesTubulares.reduce((acc, curr) => acc + curr.valoresArredondadosTubularesNecessariosPeneira12ob * curr.soma_lote_total, 0);

        this.tubulares_21 = Math.ceil(media21 / somaLoteTotal);
        this.tubulares_19 = Math.ceil(media19 / somaLoteTotal);
        this.tubulares_16 = Math.ceil(media16 / somaLoteTotal);
        this.tubulares_13ob = Math.ceil(media13ob / somaLoteTotal);
        this.tubulares_125ob = Math.ceil(media125ob / somaLoteTotal);
        this.tubulares_12ob = Math.ceil(media12ob / somaLoteTotal);

        if (this.tubulares_21 > tubularSite.peneira_21)
          this.tubulares_21 = tubularSite.peneira_21;
        if (this.tubulares_19 > tubularSite.peneira_19)
          this.tubulares_19 = tubularSite.peneira_19;
        if (this.tubulares_16 > tubularSite.peneira_16)
          this.tubulares_16 = tubularSite.peneira_16;
        if (this.tubulares_13ob > tubularSite.peneira_13ob)
          this.tubulares_13ob = tubularSite.peneira_13ob;
        if (this.tubulares_125ob > tubularSite.peneira_125ob)
          this.tubulares_125ob = tubularSite.peneira_125ob;
        if (this.tubulares_12ob > tubularSite.peneira_12ob)
          this.tubulares_12ob = tubularSite.peneira_12ob;
      } else this.enableSite = false;

      /*console.log("Tubulares disponíveis para o site " + this.selectedSite + ":");
      console.log("--------------------------------------------------");
      console.log(`Peneira 21: ${valorTubularDisponivelPeneira21} | Peneira 19: ${valorTubularDisponivelPeneira19} | Peneira 16: ${valorTubularDisponivelPeneira16} | Peneira 13ob: ${valorTubularDisponivelPeneira13ob} | Peneira 12,5ob: ${valorTubularDisponivelPeneira125ob} | Peneira 12ob: ${valorTubularDisponivelPeneira12ob}`);
      console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
      console.log("Lote: " + lote_ds);
      console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@");
      console.log("--------------------------------------------------");
      console.log("Valores iniciais do lote:");
      console.log("--------------------------------------------------");
      console.log("C1:");
      console.log(c1_prc);
      console.log("C2:");
      console.log(c2_prc);
      console.log("C3:");
      console.log(c3_prc);
      console.log("R1:");
      console.log(r1_prc);
      console.log("R2:");
      console.log(r2_prc);
      console.log("R3:");
      console.log(r3_prc);
      console.log(" ");
      console.log("Total:");
      console.log(prcValorMaterialPeneira21);
      console.log("Volume:");
      console.log(volume_ds);
      console.log("--------------------------------------------------");
      console.log("Valores: % de material passando em cada peneira:");
      console.log("--------------------------------------------------");
      console.log("Peneira 21: C1 + C2 + C3 + R1 + R2 + R3");
      console.log(valorMaterialPeneira21);
      console.log("Peneira 19/18: C2 + R2 + C3 + R3");
      console.log(valorMaterialPeneira19);
      console.log("Peneira 16/17: C3 + R3");
      console.log(valorMaterialPeneira16);
      console.log("Peneira 13ob: C1 + R1");
      console.log(valorMaterialPeneira13ob);
      console.log("Peneira 12,5ob: C2 + R2");
      console.log(valorMaterialPeneira125ob);
      console.log("Peneira 12ob: C3 + R3");
      console.log(valorMaterialPeneira12ob);
      console.log("--------------------------------------------------");
      console.log("Valores: Vazão ton/h para a peneira");
      console.log("--------------------------------------------------");
      console.log(`Peneira 21: ${this.vazaoTonPeneira21} | Peneira 19: ${this.vazaoTonPeneira19} | Peneira 16: ${this.vazaoTonPeneira16} | Peneira 13ob: ${this.vazaoTonPeneira13ob} | Peneira 12,5ob: ${this.vazaoTonPeneira125ob} | Peneira 12ob: ${this.vazaoTonPeneira12ob}`);
      console.log("--------------------------------------------------");
      console.log("valores: Vazão de cada peneira:");
      console.log("--------------------------------------------------");
      console.log("Peneira 21:");
      console.log(`${valorTubularDisponivelPeneira21}/(${valorMaterialPeneira21}/${this.vazaoTonPeneira21})= ${valorVazaoPeneira21}`);
      console.log("Peneira 19/18:");
      console.log(`${valorTubularDisponivelPeneira19}/(${valorMaterialPeneira19}/${this.vazaoTonPeneira19})= ${valorVazaoPeneira19}`);
      console.log("Peneira 16/17:");
      console.log(`${valorTubularDisponivelPeneira16}/(${valorMaterialPeneira16}/${this.vazaoTonPeneira16})= ${valorVazaoPeneira16}`);
      console.log("Peneira 13ob:");
      console.log(`${valorTubularDisponivelPeneira13ob}/(${valorMaterialPeneira13ob}/${this.vazaoTonPeneira13ob})= ${valorVazaoPeneira13ob}`);
      console.log("Peneira 12,5ob:");
      console.log(`${valorTubularDisponivelPeneira125ob}/(${valorMaterialPeneira125ob}/${this.vazaoTonPeneira125ob})= ${valorVazaoPeneira125ob}`);
      console.log("Peneira 12ob:");
      console.log(`${valorTubularDisponivelPeneira12ob}/(${valorMaterialPeneira125ob}/${this.vazaoTonPeneira12ob})= ${valorVazaoPeneira12ob}`);
      console.log("--------------------------------------------------");
      console.log("Menor vazão de cada peneira:");
      console.log("--------------------------------------------------");
      console.log(valorVazaoPeneira);
      console.log("--------------------------------------------------");
      console.log("Tubulares:");
      console.log("--------------------------------------------------");
      console.log("Peneira 21:");
      console.log(valoresTubulares21);
      console.log("Peneira 19/18:");
      console.log(valoresTubulares19);
      console.log("Peneira 16/17:");
      console.log(valoresTubulares16);
      console.log("Peneira 13ob:");
      console.log(valoresTubulares13ob);
      console.log("Peneira 12,5ob:");
      console.log(valoresTubulares125ob);
      console.log("Peneira 12ob:");
      console.log(valoresTubulares12ob);
      console.log("--------------------------------------------------");
      console.log("Tubulares Necessários, considerando a vazão da peneira");
      console.log("--------------------------------------------------");
      console.log("Peneira 21:");
      console.log(tubularesNecessariosPeneira21);
      console.log("Peneira 19/18:");
      console.log(tubularesNecessariosPeneira19);
      console.log("Peneira 16/17:");
      console.log(tubularesNecessariosPeneira16);
      console.log("Peneira 13ob:");
      console.log(tubularesNecessariosPeneira13ob);
      console.log("Peneira 12,5ob:");
      console.log(tubularesNecessariosPeneira125ob);
      console.log("Peneira 12ob:");
      console.log(tubularesNecessariosPeneira12ob);
      console.log("--------------------------------------------------");
      console.log("Tubulares Necessários considerando a vazão -  arredondar para cima, respeitando o limite de tubulares disponíveis para a peneira");
      console.log("--------------------------------------------------");
      console.log("Peneira 21:");
      console.log(tubularesNecessariosPeneira21Arredondado);
      console.log("Peneira 19/18:");
      console.log(tubularesNecessariosPeneira19Arredondado);
      console.log("Peneira 16/17:");
      console.log(tubularesNecessariosPeneira16Arredondado);
      console.log("Peneira 13ob:");
      console.log(tubularesNecessariosPeneira13obArredondado);
      console.log("Peneira 12,5ob:");
      console.log(tubularesNecessariosPeneira125obArredondado);
      console.log("Peneira 12ob:");
      console.log(tubularesNecessariosPeneira12obArredondado);
      console.log("--------------------------------------------------");
      console.log("Soma total de todos os volumes:");
      console.log("--------------------------------------------------");
      console.log(somaLoteTotal);
      console.log("--------------------------------------------------");
      console.log("Cálculo final dos tubulares");
      console.log("--------------------------------------------------");
      console.log("Peneira 21:");
      console.log(media21 + " / " + somaLoteTotal + " = " + this.tubulares_21);
      console.log("Peneira 19/18:");
      console.log(media19 + " / " + somaLoteTotal + " = " + this.tubulares_19);
      console.log("Peneira 16/17:");
      console.log(media16 + " / " + somaLoteTotal + " = " + this.tubulares_16);
      console.log("Peneira 13ob:");
      console.log(media13ob + " / " + somaLoteTotal + " = " + this.tubulares_13ob);
      console.log("Peneira 12,5ob:");
      console.log(media125ob + " / " + somaLoteTotal + " = " + this.tubulares_125ob);
      console.log("Peneira 12ob:");
      console.log(media12ob + " / " + somaLoteTotal + " = " + this.tubulares_12ob);*/
    }

    //console.log(this.listLotesTubulares);
  }

  async calculaVazoes(): Promise<void> {
    //Busca Tubulares por site
    const tubularSite = this.tubulares.find(elem => elem.site_recebimento === this.selectedSite);
    this.vazoesByContract = [];
    let vazoesByContract = [];
    this.calcularTubulares(this.orderedMarkedListByLote, tubularSite);

    this.orderedListByContract.forEach(obj => {
      //Calculo Prc por tubulares
      const prcPeneira13ob = obj.data.valor_c1_prc_pond + obj.data.valor_r1_prc_pond;
      const prcPeneira125ob = obj.data.valor_c2_prc_pond + obj.data.valor_r2_prc_pond;
      const prcPeneira12ob = obj.data.valor_c3_prc_pond + obj.data.valor_r3_prc_pond;
      const prcPeneira16ob = prcPeneira12ob + obj.data.valor_descarte_fundo_prc_pond;
      const prcPeneira19ob = prcPeneira16ob + prcPeneira125ob;
      const prcPeneira21ob = prcPeneira19ob + prcPeneira13ob;

      //Busca Lotes no Contrato
      const arrayLotesAux = this.orderedMarkedListByLote.filter(elem => elem.data.contrato_juridico === obj.data.contrato_abreviado);
      var arrayStr = '';

      const arrayLotes = arrayLotesAux.reduce((acc, current) => {
        const existing = acc.find((obj) => obj.data.lote_ds === current.data.lote_ds);
        if (!existing) {
          acc.push(current);
        }
        return acc;
      }, []);

      arrayLotes.forEach(lote => {
        arrayStr += lote.data.lote_ds + ', '
      })

      if (arrayStr.length > 2)
        arrayStr = arrayStr.slice(0, -2);

      if (tubularSite !== undefined) {
        //Calculo Vazao por tubulares
        var vazoesArray = [];
        //vazoesArray.push(tubularSite.peneira_13ob * 0.5 / (prcPeneira13ob));
        if (obj.data.valor_c1_prc_pond >= 1.5 * obj.data.valor_r1_prc_pond) {
          vazoesArray.push(tubularSite.peneira_13ob * 0.55 / (prcPeneira13ob));
        } else {
          vazoesArray.push(tubularSite.peneira_13ob * 0.5 / (prcPeneira13ob));
        }

        //vazoesArray.push(tubularSite.peneira_125ob * 0.5 / (prcPeneira125ob));
        if (obj.data.valor_c2_prc_pond >= 1.5 * obj.data.valor_r2_prc_pond) {
          vazoesArray.push(tubularSite.peneira_125ob * 0.55 / (prcPeneira125ob));
        } else {
          vazoesArray.push(tubularSite.peneira_125ob * 0.5 / (prcPeneira125ob));
        }

        //vazoesArray.push(tubularSite.peneira_12ob * 0.5 / (prcPeneira12ob));
        if (obj.data.valor_c3_prc_pond >= 1.5 * obj.data.valor_r3_prc_pond) {
          vazoesArray.push(tubularSite.peneira_12ob * 0.55 / (prcPeneira12ob));
        } else {
          vazoesArray.push(tubularSite.peneira_12ob * 0.5 / (prcPeneira12ob));
        }

        vazoesArray.push(tubularSite.peneira_16 / (prcPeneira16ob));
        vazoesArray.push(tubularSite.peneira_19 / (prcPeneira19ob));
        vazoesArray.push(tubularSite.peneira_21 / (prcPeneira21ob));

        //Busca Vazao Minima
        const vazaoMinima = Math.min(...vazoesArray);
        vazoesByContract.push({
          contrato_juridico: obj.data.contrato_abreviado,
          lote_ds: arrayStr,
          vazao: this.formatOneDecimals(vazaoMinima * 100),
          tubulares_21: this.tubulares_21,
          tubulares_19: this.tubulares_19,
          tubulares_16: this.tubulares_16,
          tubulares_13ob: this.tubulares_13ob,
          tubulares_125ob: this.tubulares_125ob,
          tubulares_12ob: this.tubulares_12ob
        })
      }
      else {
        vazoesByContract.push({
          contrato_juridico: obj.data.contrato_abreviado,
          lote_ds: arrayStr,
          tubulares_21: this.tubulares_21,
          tubulares_19: this.tubulares_19,
          tubulares_16: this.tubulares_16,
          tubulares_13ob: this.tubulares_13ob,
          tubulares_125ob: this.tubulares_125ob,
          tubulares_12ob: this.tubulares_12ob
        })
      }
      this.vazoesByContract = vazoesByContract;
    })

    this.enableTubulares = true;
  }

  async checkTempoSilo(): Promise<void> {
    this.tempoSiloByLote = [];
    this.listSec002Info.forEach(obj => {
      if (!!obj && !!obj.armazenagem_dias && !!obj.lote_ds && obj.armazenagem_dias > 45) {
        const index = this.tempoSiloByLote.findIndex(item => item.lote_ds === obj.lote_ds);
        if (index === -1 || obj.armazenagem_dias > this.tempoSiloByLote[index].dias + 45) {
          if (index !== -1) {
            this.tempoSiloByLote.splice(index, 1);
          }
          this.tempoSiloByLote.push({
            lote_ds: obj.lote_ds,
            dias: obj.armazenagem_dias - 45
          });
        }
      }
    });

    if (this.tempoSiloByLote.length > 0) {
      this.enableTempoSilo = true;
    }
  }

  calculoMediana(values: Array<any>, field: string): number {
    values.sort((a, b) => a[field] - b[field]);

    var half = Math.floor(values.length / 2);

    if (values.length % 2)
      return values[half][field];

    return (values[half - 1][field] + values[half][field]) / 2.0;
  }

  calculoMediaPond(fieldBase: string, fieldPond: string, arrayPond: Array<any>): number {
    var totalBase: number = 0;
    var totalPond: number = 0;

    // tslint:disable-next-line: max-line-length
    arrayPond.forEach(element => {
      var base: number = element[fieldBase];
      var pond: number = element[fieldPond];

      if (base !== null && base > 0 && pond !== null) {
        totalPond += (+pond) * (+base);
        totalBase += +base
      }
    });

    return totalPond / totalBase;
  }

  calculoDesvioPadrao(object: any, field: string): number {
    var array = [];

    for (let key of Object.keys(object)) {
      if (!key.startsWith('peso_medio_')) {
        array.push(this.listSequenceByContract[key][field]);
      }
    }

    const n = array.length;
    const mean = array.reduce((a, b) => a + b) / n;
    const sdev = Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n);
    return sdev;
  }

  buscarValorMinimo(object: any, field: string): number {
    var array = [];

    for (let key of Object.keys(object)) {
      if (!key.startsWith('peso_medio_')) {
        array.push(this.listSequenceByContract[key][field]);
      }
    }

    return Math.min(...array);
  }

  buscarCampoComMaiorDesvio(object: any): string {
    var maxValue = 0;
    var maxValueKey = '';

    for (let key of Object.keys(object)) {
      if (key.startsWith('peso_medio_')) {
        if (this.listSequenceByContract[key] > maxValue) {
          maxValue = this.listSequenceByContract[key];
          maxValueKey = key;
        }
      }
    }

    return maxValueKey.split('_')[2];
  }

  agruparPorFuncao(object: any, field: string) {
    var array = [];

    for (let key of Object.keys(object)) {
      if (!key.startsWith('peso_medio_')) {
        array.push(this.listSequenceByContract[key]);
      }
    }

    var r = {};
    array.forEach(data => {
      var y = Math.floor((data[field] - this.minDefeitosPond) / 2);
      r[y] = (r[y] || []).concat({ data });
    });
    return Object.keys(r).map(function (y) {
      return r[y];
    });
  }

  ordenarSequenciaSugeridaContratos(tabelaNaoSegregada: Array<any>, tabelaSegregada: Array<any>): void {
    let contratosNaoSegregados = [], contratosSegregados = [];
    for (let i = 0; i < tabelaNaoSegregada.length; i++) {
      const contratoNaoSegregado = tabelaNaoSegregada[i].data.contrato_juridico
      contratosNaoSegregados.push(contratoNaoSegregado);
    }
    contratosNaoSegregados;
    const contratosNaoSegregadosUnicos = [...new Set(contratosNaoSegregados)];

    for (let i = 0; i < tabelaSegregada.length; i++) {
      const pesquisaContrato = (contratos: string[], contrato: string) => {
        return contratosNaoSegregadosUnicos.includes(contrato);
      }
      const contratoExistente = pesquisaContrato(contratosNaoSegregadosUnicos, tabelaSegregada[i].data.contrato_juridico);
      if (!contratoExistente) {
        const contratoSegregado = tabelaSegregada[i].data.contrato_juridico
        contratosSegregados.push(contratoSegregado);
      }
    }
    const contratosSegregadosUnicos = [...new Set(contratosSegregados)];
    const ordemContratos = this.contratos.concat(contratosNaoSegregadosUnicos, contratosSegregadosUnicos);

    this.orderedListByContract = [];
    var groupNumber = 0;
    var contractNumber = 1;
    for (let i = 0; i < ordemContratos.length; i++) {
      this.groupedListByDefeitosPond.forEach(group => {
        group.forEach(element => {
          if (element.data['contrato_abreviado'] === ordemContratos[i]) {
            element.data['numero_grupo'] = groupNumber;
            element.data['contrato_numerado'] = contractNumber.toString() + ' - ' + element.data.contrato_abreviado;

            this.orderedListByContract.push(element);
            contractNumber++;
          }
        })
        groupNumber++;
      })
    }
    this.dataSourceByContract = new MatTableDataSource(this.orderedListByContract);
  }

  ordenarGrupos(values: Array<any>, field: string): void {
    values.forEach(group => {
      group.sort((a, b) => a.data['valor_defeitos_pond'] - b.data['valor_defeitos_pond']);
    })

    values.forEach(group => {
      group.sort((a, b) => a.data[field] - b.data[field]);
    })

    this.orderedListByContract = [];
    var groupNumber = 0;
    var contractNumber = 1;
    values.forEach(group => {
      group.forEach(element => {
        element.data['numero_grupo'] = groupNumber;
        element.data['contrato_numerado'] = contractNumber.toString() + ' - ' + element.data.contrato_abreviado;
        element.data['peneira_max_sdev'] = field;

        this.orderedListByContract.push(element);
        contractNumber++;
      })
      groupNumber++;
    })
  }

  formatNoDecimals(value: number): string {
    if (!!value)
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 }).format(value);
    else
      return ''
  }

  formatPercentage(value: any): string {
    if (!!value) {
      if (isNaN(+value))
        return value;
      else
        return new Intl.NumberFormat('de-DE', { style: "percent", maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value / 100);
    }
    else
      return ''
  }

  /*formatTwoDecimals(value: number): string {
    if (!!value)
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(value);
    else
      return ''
  }*/

  arredondarCasaDecimal(value: any): string {
    if (!!value || value === 0)
      return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value.toFixed(2));
    else
      return ''
  }

  formatOneDecimals(value: any): string {
    if (!!value) {
      if (isNaN(+value))
        return value;
      else
        return new Intl.NumberFormat('de-DE', { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(value);
    }
    else
      return ''
  }

  formatRowColor(value: any): string {
    if (value.data !== undefined) {
      if (!!value && value.data.numero_grupo !== null) {
        if (value.data.numero_grupo % 2)
          return 'color-even'
        return 'color-odd'
      }
      else
        return ''
    }
    else if (value[0].data !== undefined) {
      if (value.length > 0 && value[0].data.numero_grupo !== null) {
        if (value[0].data.numero_grupo % 2)
          return 'color-even'
        return 'color-odd'
      }
      else
        return ''
    }
  }

  formatCellColorDesvio5p(value: any, field: string): string {
    var classStr = '';
    let indice = 1, calculo;
    var listLotesDesvio5p = [];

    if (field === "tabelaNaoSegregada") {
      for (var i = 0; i < this.orderedMarkedListByAprovado.length; i++) {
        if (this.orderedMarkedListByAprovado[indice] !== undefined) {
          if (this.orderedMarkedListByAprovado[indice][0] !== undefined) {
            calculo = this.orderedMarkedListByAprovado[indice][0].data.total_defeitos_totais_ponderado - this.orderedMarkedListByAprovado[i][0].data.total_defeitos_totais_ponderado;
            if (Math.abs(calculo.toFixed(1)) > 5) {
              const lote = this.orderedMarkedListByAprovado[indice][0].data.lote_ds;
              listLotesDesvio5p.push(lote);
            }
          } else {
            calculo = this.orderedMarkedListByAprovado[indice].data.total_defeitos_totais_ponderado - this.orderedMarkedListByAprovado[i].data.total_defeitos_totais_ponderado;
            if (Math.abs(calculo.toFixed(1)) > 5) {
              const lote = this.orderedMarkedListByAprovado[indice].data.lote_ds;
              listLotesDesvio5p.push(lote);
            }
          }
        }
        indice++;
      }
      var array = listLotesDesvio5p.filter(elem => elem === value.data.lote_ds);
      if (array.length > 0) {
        classStr += 'color-pink';
        this.enableLegendaDesvio5p = true;
      }
    }
    else if (field === "tabelaSegregada") {
      for (var i = 0; i < this.orderedMarkedListByLoteSegregadoInicialReal.length; i++) {
        if (this.orderedMarkedListByLoteSegregadoInicialReal[indice] !== undefined) {
          if (this.orderedMarkedListByLoteSegregadoInicialReal[indice][0] !== undefined) {
            calculo = this.orderedMarkedListByLoteSegregadoInicialReal[indice][0].data.total_defeitos_totais_ponderado - this.orderedMarkedListByLoteSegregadoInicialReal[i][0].data.total_defeitos_totais_ponderado;
            if (Math.abs(calculo.toFixed(1)) > 5) {
              const lote = this.orderedMarkedListByLoteSegregadoInicialReal[indice][0].data.lote_ds;
              listLotesDesvio5p.push(lote);
            }
          } else {
            calculo = this.orderedMarkedListByLoteSegregadoInicialReal[indice].data.total_defeitos_totais_ponderado - this.orderedMarkedListByLoteSegregadoInicialReal[i].data.total_defeitos_totais_ponderado;
            if (Math.abs(calculo.toFixed(1)) > 5) {
              const lote = this.orderedMarkedListByLoteSegregadoInicialReal[indice].data.lote_ds;
              listLotesDesvio5p.push(lote);
            }
          }
        }
        indice++;
      }
      var array = listLotesDesvio5p.filter(elem => elem === value.data.lote_ds);
      if (array.length > 0) {
        classStr += 'color-pink';
        this.enableLegendaDesvio5p = true;
      }
    }

    return classStr;
  }

  formatCellColor(value: any, field: string, peneira: string): string {
    var classStr = '';

    if (value.data !== undefined) {
      if (!!value.data[field])
        classStr += 'color-yellow'

      if (value.data.numero_grupo === null) {
        if (value.data.peneira_max_sdev !== null) {
          const maxSdevPeneira: string = value.data.peneira_max_sdev;
          if (maxSdevPeneira.includes(peneira))
            classStr += ' text-sdev-max'
        }
        classStr += ' text-sdev'
      }
    }
    else if (value[0].data !== undefined) {
      if (!!value[0].data[field])
        classStr += 'color-yellow'

      if (value[0].data.numero_grupo === null) {
        if (value[0].data.peneira_max_sdev !== null) {
          const maxSdevPeneira: string = value[0].data.peneira_max_sdev;
          if (maxSdevPeneira.includes(peneira))
            classStr += ' text-sdev-max'
        }
        classStr += ' text-sdev'
      }
    }


    return classStr;
  }

  formatCellGroup(value: any, field: string): string {
    var classStr = '';

    if (value.data !== undefined) {
      if (!!value.data[field])
        classStr += 'color-orange'

      if (value.data.numero_grupo === null) {
        classStr += ' text-sdev'
      }
    }
    else if (value[0].data !== undefined) {
      if (!!value[0].data[field])
        classStr += 'color-orange'

      if (value[0].data.numero_grupo === null) {
        classStr += ' text-sdev'
      }
    }

    return classStr
  }

  formatCellText(value: any, columnName: string): string {
    if (value.data !== undefined) {
      if (value.data.numero_grupo === null) {
        if (value.data.peneira_max_sdev !== null) {
          const maxSdevPeneira: string = value.data.peneira_max_sdev;
          if (maxSdevPeneira.includes(columnName))
            return 'text-sdev-max'
        }
        return 'text-sdev'
      }
      else
        return ''
    }
    else if (value[0].data !== undefined) {
      if (value[0].data.numero_grupo === null) {
        if (value[0].data.peneira_max_sdev !== null) {
          const maxSdevPeneira: string = value[0].data.peneira_max_sdev;
          if (maxSdevPeneira.includes(columnName))
            return 'text-sdev-max'
        }
        return 'text-sdev'
      }
      else
        return ''
    }
  }

  formatSiloCellTextColor(value: any, arquivo: string): string {
    if (value.data !== undefined) {
      if (value.data.faixas_qual.includes('Vermelha')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasVermelhas.push(value);
          this.tabelaFaixasVermelhas.forEach(element => { element['grupo_faixa'] = 4; });
        }
        return 'color-faixa-vermelho';
      }
      else if (value.data.faixas_qual.includes('Escuro')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulEscuro.push(value);
          this.tabelaFaixasAzulEscuro.forEach(element => { element['grupo_faixa'] = 3; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-escuro';
      }
      else if (value.data.faixas_qual.includes('Campo')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulCampo.push(value);
          this.tabelaFaixasAzulCampo.forEach(element => { element['grupo_faixa'] = 2; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-campo-planta';
      }
      else if (value.data.faixas_qual.includes('Ressecagem') || value.data.faixas_qual.includes('Umidade de colheita')
        || value.data.faixas_qual.includes('Temperatura de Secagem') || value.data.faixas_qual.includes('Sem Vapor ou Ventilação')
        || value.data.faixas_qual.includes('Transbordo')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulPlanta.push(value);
          this.tabelaFaixasAzulPlanta.forEach(element => { element['grupo_faixa'] = 2; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-campo-planta';
      }
      else if (value.data.faixas_qual.includes('Claro')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulClaro.push(value);
          this.tabelaFaixasAzulClaro.forEach(element => { element['grupo_faixa'] = 1; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-claro';
      }
      else if (value.data.faixas_qual.includes('Laranja'))
        return 'color-faixa-laranja';
      else if (value.data.faixas_qual.includes('Cinza'))
        return 'color-faixa-cinza';
      else if (value.data.faixas_qual.includes('Roxa'))
        return 'color-faixa-roxa';
      else if (value.data.faixas_qual === 'Faixa Livre')
        return 'color-faixa-livre';
      return null;
    } else if (value[0].data !== undefined) {
      if (value[0].data.faixas_qual.includes('Vermelha')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasVermelhas.push(value);
          this.tabelaFaixasVermelhas.forEach(element => { element['grupo_faixa'] = 4; });
        }
        return 'color-faixa-vermelho';
      }
      else if (value[0].data.faixas_qual.includes('Escuro')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulEscuro.push(value);
          this.tabelaFaixasAzulEscuro.forEach(element => { element['grupo_faixa'] = 3; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-escuro';
      }
      else if (value[0].data.faixas_qual.includes('Campo')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulCampo.push(value);
          this.tabelaFaixasAzulCampo.forEach(element => { element['grupo_faixa'] = 2; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-campo-planta';
      }
      else if (value[0].data.faixas_qual.includes('Ressecagem') || value[0].data.faixas_qual.includes('Umidade de colheita')
        || value[0].data.faixas_qual.includes('Temperatura de Secagem') || value[0].data.faixas_qual.includes('Sem Vapor ou Ventilação')
        || value[0].data.faixas_qual.includes('Transbordo')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulPlanta.push(value);
          this.tabelaFaixasAzulPlanta.forEach(element => { element['grupo_faixa'] = 2; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-campo-planta';
      }
      else if (value[0].data.faixas_qual.includes('Claro')) {
        if (arquivo.toUpperCase() === "TS".toUpperCase()) {
          this.tabelaFaixasAzulClaro.push(value);
          this.tabelaFaixasAzulClaro.forEach(element => { element['grupo_faixa'] = 1; });
          this.tabelaSemFaixasVermelhas.push(value);
        }
        return 'color-faixa-azul-claro';
      }
      else if (value[0].data.faixas_qual.includes('Laranja'))
        return 'color-faixa-laranja';
      else if (value[0].data.faixas_qual.includes('Cinza'))
        return 'color-faixa-cinza';
      else if (value[0].data.faixas_qual.includes('Roxa'))
        return 'color-faixa-roxa';
      else if (value[0].data.faixas_qual === 'Faixa Livre')
        return 'color-faixa-livre';
      return null;
    }
  }

  formatTextColor(value: any): boolean {
    if (value.data !== undefined) {
      return this.repeatedDiscardedValues.includes(value.data.lote_ds);
    }
    else if (value[0].data !== undefined) {
      return this.repeatedDiscardedValues.includes(value[0].data.lote_ds);
    }
  }

  listaMudancaTipoColheita(array: Array<any>): void {
    this.listChangedTipoColheita = [];
    this.enableTipoColheita = false;
    array.reduce((prev, curr) => {
      if (typeof prev.data.tipo_colheita) {
        if ((prev.data.tipo_colheita?.toUpperCase() === 'GRANEL' || prev.data.tipo_colheita?.toUpperCase() === 'ESPIGA')
          && (curr.data.tipo_colheita?.toUpperCase() === 'GRANEL' || curr.data.tipo_colheita?.toUpperCase() === 'ESPIGA')) {
          if (prev.data.tipo_colheita !== curr.data.tipo_colheita) {
            this.listChangedTipoColheita.push(
              {
                contratos: prev.data.contrato_abreviado + ' e ' + curr.data.contrato_abreviado,
                tipos: prev.data.tipo_colheita + ' para ' + curr.data.tipo_colheita
              });
          }
        }


      }
      return curr;
    });

    if (this.listChangedTipoColheita.length > 0) {
      this.enableTipoColheita = true;
    }
  }

  agruparPorLote(arrayByContract: Array<any>, field: string) {
    var r = {};
    arrayByContract.forEach(data => {
      var y = Math.floor((data[field] - this.minDefeitosPondLote) / 2);
      r[y] = (r[y] || []).concat({ data });
    });
    return Object.keys(r).map(function (y) {
      return r[y];
    });
  }

  buscarValorMinimoByLote(arrayByContract: Array<any>, field: string): number {
    var array = [];

    arrayByContract.forEach(element => {
      array.push(element[field]);
    })

    return Math.min(...array);
  }

  calculoDesvioPadraoByLote(arrayByContract: Array<any>, field: string): number {
    var array = [];

    arrayByContract.forEach(element => {
      array.push(element[field]);
    })

    const n = array.length;
    const mean = array.reduce((a, b) => a + b) / n;
    const sdev = Math.sqrt(array.map(x => Math.pow(x - mean, 2)).reduce((a, b) => a + b) / n);
    return sdev;
  }

  calcularPesoMedioPonderado(arrayByContract: Array<any>, field: string): number {
    var array = [];

    arrayByContract.forEach(element => {
      array.push(element[field]);
    })

    this.calculoPesoMedioPonderado = array.reduce((a, b) => b - a) / 1.8;

    return this.calculoPesoMedioPonderado;
  }

  calcularDefeitosTotaisPonderado(arrayByContract: Array<any>, field: string): number {
    var array = [];

    arrayByContract.forEach(element => {
      array.push(element[field]);
    })

    this.calculoDefeitosTotaisPonderado = array.reduce((a, b) => b - a) / 4.5;

    return this.calculoDefeitosTotaisPonderado;
  }

  calcularTotalSequenciamento(): any {
    const calculo = this.calculoDefeitosTotaisPonderado + this.calculoPesoMedioPonderado;

    return calculo;
  }

  buscarCampoComMaiorDesvioByLote(object: any): string {
    var maxValue = 0;
    var maxValueKey = '';

    for (let key of Object.keys(object)) {
      if (key.startsWith('peso_medio_')) {
        if (object[key] > maxValue) {
          maxValue = object[key];
          maxValueKey = key;
        }
      }
    }

    return maxValueKey.split('_')[2];
  }

  ordenarGruposByLote(values: Array<any>, field: string): void {
    /*values.forEach(group => {
      group.sort((a, b) => a.data['total_defeitos_totais_ponderado'] - b.data['total_defeitos_totais_ponderado']);
    })

    values.forEach(group => {
      group.sort((a, b) => a.data[field] - b.data[field]);
    })*/
    if (this.selectedPrioridadeSequenciamento === 2) {
      values.forEach(group => {
        group.sort((a, b) => b.data['peso_medio_ponderado'] - a.data['peso_medio_ponderado'] &&
          b.data['total_defeitos_totais_ponderado'] - a.data['total_defeitos_totais_ponderado']);
      })

      values.forEach(group => {
        group.sort((a, b) => b.data[field] - a.data[field]);
      })
    }
    else {
      values.forEach(group => {
        group.sort((a, b) => a.data['peso_medio_ponderado'] - b.data['peso_medio_ponderado'] &&
          a.data['total_defeitos_totais_ponderado'] - b.data['total_defeitos_totais_ponderado'])
      })

      values.forEach(group => {
        group.sort((a, b) => a.data[field] - b.data[field]);
      })
    }

    var groupNumber = 0;

    values.forEach(group => {
      group.forEach(element => {
        element.data['numero_grupo'] = groupNumber;
        element.data['lote_numerado'] = /*this.loteNumber.toString() + ' - ' + */element.data.lote_ds;
        element.data['peneira_max_sdev'] = field;

        this.orderedListByLote.push(element);
        this.loteNumber++;
      })
      groupNumber++;
    })
  }

  marcaAltaVariacao(values: Array<any>, contract: string, chamador: number): void {
    var array = values.filter(elem => elem.data.contrato_juridico === contract);
    if (chamador === 1) {
      //Variacao Alta G2 e G3
      values.reduce((prev, curr) => {
        var prcG2G3Prev = prev.data['c2_prc'] + prev.data['c3_prc'] + prev.data['r2_prc'] + prev.data['r3_prc'];
        var prcG2G3Curr = curr.data['c2_prc'] + curr.data['c3_prc'] + curr.data['r2_prc'] + curr.data['r3_prc'];
        let calculo = prcG2G3Curr - prcG2G3Prev;
        let resultado = Math.abs(calculo);

        if (resultado > 15) {
          curr.data['g2_g3_variacao'] = true;
          this.enableLegendaLaranja = true;
        } else
          curr.data['g2_g3_variacao'] = false;

        return curr;
      })
      /*values.reduce((prev, curr) => {
        var prcG2G3Prev = prev.data['c2_prc'] + prev.data['c3_prc'] + prev.data['r2_prc'] + prev.data['r3_prc'];
        var prcG2G3Curr = curr.data['c2_prc'] + curr.data['c3_prc'] + curr.data['r2_prc'] + curr.data['r3_prc'];

        if (prcG2G3Curr - prcG2G3Prev < -15) {
          curr.data['g2_g3_variacao'] = true;
          this.enableLegendaLaranja = true;
        }
        return curr;
      })*/

      //Variacao Alta de Peso Medio
      this.fieldsSequenceByContract.forEach(fieldName => {
        if (fieldName.startsWith('peso_medio')) {
          values.reduce((prev, curr) => {
            let vCurr = curr.data[fieldName];
            let vPrev = prev.data[fieldName];
            if (vCurr !== null && vPrev !== null) {
              let vCurrAbs = Math.abs(curr.data[fieldName]);
              let vPrevAbs = Math.abs(prev.data[fieldName]);
              let subtracao = Math.abs(vCurrAbs - vPrevAbs);
              let multiplicacao = Math.abs(vPrevAbs * 0.20);
              if (subtracao > multiplicacao) {
                curr.data[fieldName + '_variacao'] = true;
                this.enableLegendaAmarela = true;
              } else
                curr.data[fieldName + '_variacao'] = false;
            } else
              curr.data[fieldName + '_variacao'] = false;

            return curr;
          })
        }
      })
    }
    /*this.fieldsSequenceByContract.forEach(fieldName => {
      if (fieldName.startsWith('peso_medio')) {
        values.reduce((prev, curr) => {
          if (Math.abs(curr.data[fieldName] - prev.data[fieldName]) > prev.data[fieldName] * 0.20) {
            curr.data[fieldName + '_variacao'] = true;
            this.enableLegendaAmarela = true;
          }

          return curr;
        })
      }
    })*/

    array.forEach(element => {
      element.data['g2_g3_total'] = element.data['c2_prc'] + element.data['c3_prc'] + element.data['r2_prc'] + element.data['r3_prc'];
      this.orderedMarkedListByLote.push(element);
      this.orderedMarkedListByLoteSegregado.push(element);
      this.orderedMarkedListByLoteNaoSegregado.push(element);
    })
  }

  removerRepetidos(values: Array<any>): Array<any> {
    // Remove repetidos em Contratos Diferentes
    var repeated = values
      .map(e => e['lote_ds'])
      .map((e, i, final) => final.indexOf(e) !== i && i)
      .filter(obj => values[obj])
      .map(e => values[e]["lote_ds"]);

    this.repeatedDiscardedValues = repeated;
    if (repeated.length > 0) {
      repeated.forEach(element => {
        var duplicates = values.filter(obj => element === obj.lote_ds);
        var maxValue = duplicates.reduce((prev, curr) => {
          return (prev.volume_ds >= curr.volume_ds) ? prev : curr;
        });

        values = values.filter(obj => !((obj.lote_ds === maxValue.lote_ds) && (obj.contrato_juridico !== maxValue.contrato_juridico)));
      });
      this.enableLegendaVermelha = true;
    }

    // Remove repetidos em Contratos Iguais
    var repeated = values
      .map(e => e['lote_ds'])
      .map((e, i, final) => final.indexOf(e) !== i && i)
      .filter(obj => values[obj])
      .map(e => values[e]["lote_ds"]);

    if (repeated.length > 0) {
      repeated.forEach(element => {
        var maxValue = values.find(obj => element === obj.lote_ds);

        values = values.filter(obj => !((obj.lote_ds === maxValue.lote_ds) && (obj.contrato_juridico === maxValue.contrato_juridico) && (obj !== maxValue)));
      });
    }
    return values;
  }

  getFaixasDeQualidade(values: Array<any>): void {
    values.forEach(element => {
      const secInfos = this.listSec002Info.filter(secValue => ((secValue.lote_ds === element.data.lote_ds)));
      var faixasValue = '';

      if (secInfos.length > 0) {
        secInfos.forEach(secInfo => {
          if ((!!secInfo.faixa_azul_campo && !secInfo.faixa_azul_campo.toUpperCase().includes('SEM'))
            || (!!secInfo.faixa_azul_umidade_de_colheita && secInfo.faixa_azul_umidade_de_colheita.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_temperatura_de_secagem && secInfo.faixa_azul_temperatura_de_secagem.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_sem_vapor_ou_ventilacao && secInfo.faixa_azul_sem_vapor_ou_ventilacao.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_ressecagem && secInfo.faixa_azul_ressecagem.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_transbordo && secInfo.faixa_azul_transbordo.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_claro_temperatura_carga && secInfo.faixa_azul_claro_temperatura_carga.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_claro_tempo_de_patio && secInfo.faixa_azul_claro_tempo_de_patio.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_escuro_temperatura_carga && secInfo.faixa_azul_escuro_temperatura_carga.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_escuro_tempo_de_patio && secInfo.faixa_azul_escuro_tempo_de_patio.toUpperCase() === 'SIM')
            || (!!secInfo.faixa_azul_escuro_granel_tempo_de_transporte && secInfo.faixa_azul_escuro_granel_tempo_de_transporte.toUpperCase() === 'SIM')
          ) {
            if (!faixasValue.includes('Azul') && !faixasValue.includes('Azul('))
              faixasValue += 'Azul(';
            if (!!secInfo.faixa_azul_campo && !secInfo.faixa_azul_campo.toUpperCase().includes('SEM') && !faixasValue.toUpperCase().includes(secInfo.faixa_azul_campo.toUpperCase())) {
              if (!faixasValue.includes('Campo'))
                faixasValue += 'Campo - ' + secInfo.faixa_azul_campo + ' ';
              else
                faixasValue += secInfo.faixa_azul_campo + ' ';
            }
            if (!!secInfo.faixa_azul_umidade_de_colheita && secInfo.faixa_azul_umidade_de_colheita.toUpperCase() === 'SIM' && !faixasValue.includes('Umidade de colheita'))
              faixasValue += ' Umidade de colheita;'
            if (!!secInfo.faixa_azul_temperatura_de_secagem && secInfo.faixa_azul_temperatura_de_secagem.toUpperCase() === 'SIM' && !faixasValue.includes('Temperatura de Secagem'))
              faixasValue += ' Temperatura de Secagem;'
            if (!!secInfo.faixa_azul_sem_vapor_ou_ventilacao && secInfo.faixa_azul_sem_vapor_ou_ventilacao.toUpperCase() === 'SIM' && !faixasValue.includes('Sem Vapor ou Ventilação'))
              faixasValue += ' Sem Vapor ou Ventilação;'
            if (!!secInfo.faixa_azul_ressecagem && secInfo.faixa_azul_ressecagem.toUpperCase() === 'SIM' && !faixasValue.includes('Ressecagem'))
              faixasValue += ' Ressecagem;'
            if (!!secInfo.faixa_azul_transbordo && secInfo.faixa_azul_transbordo.toUpperCase() === 'SIM' && !faixasValue.includes('Transbordo'))
              faixasValue += ' Transbordo;'
            if (!!secInfo.faixa_azul_claro_temperatura_carga && secInfo.faixa_azul_claro_temperatura_carga.toUpperCase() === 'SIM' && !faixasValue.includes('Temperatura - Claro'))
              faixasValue += ' Temperatura - Claro;'
            if (!!secInfo.faixa_azul_claro_tempo_de_patio && secInfo.faixa_azul_claro_tempo_de_patio.toUpperCase() === 'SIM' && !faixasValue.includes('Tempo de Pátio - Claro'))
              faixasValue += ' Tempo de Pátio - Claro;'
            if (!!secInfo.faixa_azul_escuro_temperatura_carga && secInfo.faixa_azul_escuro_temperatura_carga.toUpperCase() === 'SIM' && !faixasValue.includes('Temperatura - Escuro'))
              faixasValue += ' Temperatura - Escuro;'
            if (!!secInfo.faixa_azul_escuro_tempo_de_patio && secInfo.faixa_azul_escuro_tempo_de_patio.toUpperCase() === 'SIM' && !faixasValue.includes('Tempo de Pátio - Escuro'))
              faixasValue += ' Tempo de Pátio - Escuro;'
            if (!!secInfo.faixa_azul_escuro_granel_tempo_de_transporte && secInfo.faixa_azul_escuro_granel_tempo_de_transporte.toUpperCase() === 'SIM' && !faixasValue.includes('Granel Tempo de Transporte - Escuro'))
              faixasValue += ' Granel Tempo de Transporte - Escuro;'
          }
        })

        if (faixasValue.length > 0)
          faixasValue += '); ';

        secInfos.forEach(secInfo => {
          if (!!secInfo.faixa_vermelha && secInfo.faixa_vermelha.toUpperCase() === 'SIM' && !faixasValue.includes('Vermelha'))
            faixasValue += 'Vermelha; ';
          if (!!secInfo.faixa_roxa && secInfo.faixa_roxa.toUpperCase() === 'SIM' && !faixasValue.includes('Roxa'))
            faixasValue += 'Roxa; ';
          if (!!secInfo.faixa_laranja && secInfo.faixa_laranja.toUpperCase() === 'SIM' && !faixasValue.includes('Laranja'))
            faixasValue += 'Laranja; ';
          if (!!secInfo.faixa_cinza && secInfo.faixa_cinza.toUpperCase() === 'SIM' && !faixasValue.includes('Cinza'))
            faixasValue += 'Cinza; ';
          // if (!!secInfo.faixa_marrom && secInfo.faixa_marrom.toUpperCase() === 'SIM' && !faixasValue.includes('Marrom'))
          //   faixasValue += 'Marrom; ';
        })
      }
      if (faixasValue.length > 0)
        element.data['faixas_qual'] = faixasValue;
      else
        element.data['faixas_qual'] = 'Faixa Livre';
    });
  }
}
